
/*!
* @name JS Class: HTMLDsbElement+fetch,mustache - ES Module
* @desc Provides base class with fetch,mustache for DSB webcomponents (workbench compatable)
* @version v1.1.0
* @website undefined
* @license ISC
* @copyright (c) 2026
* @author fw@maa
*/
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
  return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var mustache = createCommonjsModule(function (module, exports) {
  (function (global, factory) {
    module.exports = factory();
  })(commonjsGlobal, function () {
    /*!
                                   * mustache.js - Logic-less {{mustache}} templates with JavaScript
                                   * http://github.com/janl/mustache.js
                                   */

    var objectToString = Object.prototype.toString;
    var isArray = Array.isArray || function isArrayPolyfill(object) {
      return objectToString.call(object) === '[object Array]';
    };

    function isFunction(object) {
      return typeof object === 'function';
    }

    /**
       * More correct typeof string handling array
       * which normally returns typeof 'object'
       */
    function typeStr(obj) {
      return isArray(obj) ? 'array' : typeof obj;
    }

    function escapeRegExp(string) {
      return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');
    }

    /**
       * Null safe way of checking whether or not an object,
       * including its prototype, has a given property
       */
    function hasProperty(obj, propName) {
      return obj != null && typeof obj === 'object' && propName in obj;
    }

    /**
       * Safe way of detecting whether or not the given thing is a primitive and
       * whether it has the given property
       */
    function primitiveHasOwnProperty(primitive, propName) {
      return (
        primitive != null &&
        typeof primitive !== 'object' &&
        primitive.hasOwnProperty &&
        primitive.hasOwnProperty(propName));

    }

    // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
    // See https://github.com/janl/mustache.js/issues/189
    var regExpTest = RegExp.prototype.test;
    function testRegExp(re, string) {
      return regExpTest.call(re, string);
    }

    var nonSpaceRe = /\S/;
    function isWhitespace(string) {
      return !testRegExp(nonSpaceRe, string);
    }

    var entityMap = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
      '/': '&#x2F;',
      '`': '&#x60;',
      '=': '&#x3D;' };


    function escapeHtml(string) {
      return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap(s) {
        return entityMap[s];
      });
    }

    var whiteRe = /\s*/;
    var spaceRe = /\s+/;
    var equalsRe = /\s*=/;
    var curlyRe = /\s*\}/;
    var tagRe = /#|\^|\/|>|\{|&|=|!/;

    /**
                                       * Breaks up the given `template` string into a tree of tokens. If the `tags`
                                       * argument is given here it must be an array with two string values: the
                                       * opening and closing tags used in the template (e.g. [ "<%", "%>" ]). Of
                                       * course, the default is to use mustaches (i.e. mustache.tags).
                                       *
                                       * A token is an array with at least 4 elements. The first element is the
                                       * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
                                       * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
                                       * all text that appears outside a symbol this element is "text".
                                       *
                                       * The second element of a token is its "value". For mustache tags this is
                                       * whatever else was inside the tag besides the opening symbol. For text tokens
                                       * this is the text itself.
                                       *
                                       * The third and fourth elements of the token are the start and end indices,
                                       * respectively, of the token in the original template.
                                       *
                                       * Tokens that are the root node of a subtree contain two more elements: 1) an
                                       * array of tokens in the subtree and 2) the index in the original template at
                                       * which the closing tag for that section begins.
                                       *
                                       * Tokens for partials also contain two more elements: 1) a string value of
                                       * indendation prior to that tag and 2) the index of that tag on that line -
                                       * eg a value of 2 indicates the partial is the third tag on this line.
                                       */
    function parseTemplate(template, tags) {
      if (!template)
      return [];
      var lineHasNonSpace = false;
      var sections = []; // Stack to hold section tokens
      var tokens = []; // Buffer to hold the tokens
      var spaces = []; // Indices of whitespace tokens on the current line
      var hasTag = false; // Is there a {{tag}} on the current line?
      var nonSpace = false; // Is there a non-space char on the current line?
      var indentation = ''; // Tracks indentation for tags that use it
      var tagIndex = 0; // Stores a count of number of tags encountered on a line

      // Strips all whitespace tokens array for the current line
      // if there was a {{#tag}} on it and otherwise only space.
      function stripSpace() {
        if (hasTag && !nonSpace) {
          while (spaces.length)
          delete tokens[spaces.pop()];
        } else {
          spaces = [];
        }

        hasTag = false;
        nonSpace = false;
      }

      var openingTagRe, closingTagRe, closingCurlyRe;
      function compileTags(tagsToCompile) {
        if (typeof tagsToCompile === 'string')
        tagsToCompile = tagsToCompile.split(spaceRe, 2);

        if (!isArray(tagsToCompile) || tagsToCompile.length !== 2)
        throw new Error('Invalid tags: ' + tagsToCompile);

        openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + '\\s*');
        closingTagRe = new RegExp('\\s*' + escapeRegExp(tagsToCompile[1]));
        closingCurlyRe = new RegExp('\\s*' + escapeRegExp('}' + tagsToCompile[1]));
      }

      compileTags(tags || mustache.tags);

      var scanner = new Scanner(template);

      var start, type, value, chr, token, openSection;
      while (!scanner.eos()) {
        start = scanner.pos;

        // Match any text between tags.
        value = scanner.scanUntil(openingTagRe);

        if (value) {
          for (var i = 0, valueLength = value.length; i < valueLength; ++i) {
            chr = value.charAt(i);

            if (isWhitespace(chr)) {
              spaces.push(tokens.length);
              indentation += chr;
            } else {
              nonSpace = true;
              lineHasNonSpace = true;
              indentation += ' ';
            }

            tokens.push(['text', chr, start, start + 1]);
            start += 1;

            // Check for whitespace on the current line.
            if (chr === '\n') {
              stripSpace();
              indentation = '';
              tagIndex = 0;
              lineHasNonSpace = false;
            }
          }
        }

        // Match the opening tag.
        if (!scanner.scan(openingTagRe))
        break;

        hasTag = true;

        // Get the tag type.
        type = scanner.scan(tagRe) || 'name';
        scanner.scan(whiteRe);

        // Get the tag value.
        if (type === '=') {
          value = scanner.scanUntil(equalsRe);
          scanner.scan(equalsRe);
          scanner.scanUntil(closingTagRe);
        } else if (type === '{') {
          value = scanner.scanUntil(closingCurlyRe);
          scanner.scan(curlyRe);
          scanner.scanUntil(closingTagRe);
          type = '&';
        } else {
          value = scanner.scanUntil(closingTagRe);
        }

        // Match the closing tag.
        if (!scanner.scan(closingTagRe))
        throw new Error('Unclosed tag at ' + scanner.pos);

        if (type == '>') {
          token = [type, value, start, scanner.pos, indentation, tagIndex, lineHasNonSpace];
        } else {
          token = [type, value, start, scanner.pos];
        }
        tagIndex++;
        tokens.push(token);

        if (type === '#' || type === '^') {
          sections.push(token);
        } else if (type === '/') {
          // Check section nesting.
          openSection = sections.pop();

          if (!openSection)
          throw new Error('Unopened section "' + value + '" at ' + start);

          if (openSection[1] !== value)
          throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
        } else if (type === 'name' || type === '{' || type === '&') {
          nonSpace = true;
        } else if (type === '=') {
          // Set the tags for the next time around.
          compileTags(value);
        }
      }

      stripSpace();

      // Make sure there are no open sections when we're done.
      openSection = sections.pop();

      if (openSection)
      throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);

      return nestTokens(squashTokens(tokens));
    }

    /**
       * Combines the values of consecutive text tokens in the given `tokens` array
       * to a single token.
       */
    function squashTokens(tokens) {
      var squashedTokens = [];

      var token, lastToken;
      for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
        token = tokens[i];

        if (token) {
          if (token[0] === 'text' && lastToken && lastToken[0] === 'text') {
            lastToken[1] += token[1];
            lastToken[3] = token[3];
          } else {
            squashedTokens.push(token);
            lastToken = token;
          }
        }
      }

      return squashedTokens;
    }

    /**
       * Forms the given array of `tokens` into a nested tree structure where
       * tokens that represent a section have two additional items: 1) an array of
       * all tokens that appear in that section and 2) the index in the original
       * template that represents the end of that section.
       */
    function nestTokens(tokens) {
      var nestedTokens = [];
      var collector = nestedTokens;
      var sections = [];

      var token, section;
      for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
        token = tokens[i];

        switch (token[0]) {
          case '#':
          case '^':
            collector.push(token);
            sections.push(token);
            collector = token[4] = [];
            break;
          case '/':
            section = sections.pop();
            section[5] = token[2];
            collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
            break;
          default:
            collector.push(token);}

      }

      return nestedTokens;
    }

    /**
       * A simple string scanner that is used by the template parser to find
       * tokens in template strings.
       */
    function Scanner(string) {
      this.string = string;
      this.tail = string;
      this.pos = 0;
    }

    /**
       * Returns `true` if the tail is empty (end of string).
       */
    Scanner.prototype.eos = function eos() {
      return this.tail === '';
    };

    /**
        * Tries to match the given regular expression at the current position.
        * Returns the matched text if it can match, the empty string otherwise.
        */
    Scanner.prototype.scan = function scan(re) {
      var match = this.tail.match(re);

      if (!match || match.index !== 0)
      return '';

      var string = match[0];

      this.tail = this.tail.substring(string.length);
      this.pos += string.length;

      return string;
    };

    /**
        * Skips all text until the given regular expression can be matched. Returns
        * the skipped string, which is the entire tail if no match can be made.
        */
    Scanner.prototype.scanUntil = function scanUntil(re) {
      var index = this.tail.search(re),match;

      switch (index) {
        case -1:
          match = this.tail;
          this.tail = '';
          break;
        case 0:
          match = '';
          break;
        default:
          match = this.tail.substring(0, index);
          this.tail = this.tail.substring(index);}


      this.pos += match.length;

      return match;
    };

    /**
        * Represents a rendering context by wrapping a view object and
        * maintaining a reference to the parent context.
        */
    function Context(view, parentContext) {
      this.view = view;
      this.cache = { '.': this.view };
      this.parent = parentContext;
    }

    /**
       * Creates a new context using the given view with this context
       * as the parent.
       */
    Context.prototype.push = function push(view) {
      return new Context(view, this);
    };

    /**
        * Returns the value of the given name in this context, traversing
        * up the context hierarchy if the value is absent in this context's view.
        */
    Context.prototype.lookup = function lookup(name) {
      var cache = this.cache;

      var value;
      if (cache.hasOwnProperty(name)) {
        value = cache[name];
      } else {
        var context = this,intermediateValue,names,index,lookupHit = false;

        while (context) {
          if (name.indexOf('.') > 0) {
            intermediateValue = context.view;
            names = name.split('.');
            index = 0;

            /**
                        * Using the dot notion path in `name`, we descend through the
                        * nested objects.
                        *
                        * To be certain that the lookup has been successful, we have to
                        * check if the last object in the path actually has the property
                        * we are looking for. We store the result in `lookupHit`.
                        *
                        * This is specially necessary for when the value has been set to
                        * `undefined` and we want to avoid looking up parent contexts.
                        *
                        * In the case where dot notation is used, we consider the lookup
                        * to be successful even if the last "object" in the path is
                        * not actually an object but a primitive (e.g., a string, or an
                        * integer), because it is sometimes useful to access a property
                        * of an autoboxed primitive, such as the length of a string.
                        **/
            while (intermediateValue != null && index < names.length) {
              if (index === names.length - 1)
              lookupHit =
              hasProperty(intermediateValue, names[index]) ||
              primitiveHasOwnProperty(intermediateValue, names[index]);


              intermediateValue = intermediateValue[names[index++]];
            }
          } else {
            intermediateValue = context.view[name];

            /**
                                                     * Only checking against `hasProperty`, which always returns `false` if
                                                     * `context.view` is not an object. Deliberately omitting the check
                                                     * against `primitiveHasOwnProperty` if dot notation is not used.
                                                     *
                                                     * Consider this example:
                                                     * ```
                                                     * Mustache.render("The length of a football field is {{#length}}{{length}}{{/length}}.", {length: "100 yards"})
                                                     * ```
                                                     *
                                                     * If we were to check also against `primitiveHasOwnProperty`, as we do
                                                     * in the dot notation case, then render call would return:
                                                     *
                                                     * "The length of a football field is 9."
                                                     *
                                                     * rather than the expected:
                                                     *
                                                     * "The length of a football field is 100 yards."
                                                     **/
            lookupHit = hasProperty(context.view, name);
          }

          if (lookupHit) {
            value = intermediateValue;
            break;
          }

          context = context.parent;
        }

        cache[name] = value;
      }

      if (isFunction(value))
      value = value.call(this.view);

      return value;
    };

    /**
        * A Writer knows how to take a stream of tokens and render them to a
        * string, given a context. It also maintains a cache of templates to
        * avoid the need to parse the same template twice.
        */
    function Writer() {
      this.templateCache = {
        _cache: {},
        set: function set(key, value) {
          this._cache[key] = value;
        },
        get: function get(key) {
          return this._cache[key];
        },
        clear: function clear() {
          this._cache = {};
        } };

    }

    /**
       * Clears all cached templates in this writer.
       */
    Writer.prototype.clearCache = function clearCache() {
      if (typeof this.templateCache !== 'undefined') {
        this.templateCache.clear();
      }
    };

    /**
        * Parses and caches the given `template` according to the given `tags` or
        * `mustache.tags` if `tags` is omitted,  and returns the array of tokens
        * that is generated from the parse.
        */
    Writer.prototype.parse = function parse(template, tags) {
      var cache = this.templateCache;
      var cacheKey = template + ':' + (tags || mustache.tags).join(':');
      var isCacheEnabled = typeof cache !== 'undefined';
      var tokens = isCacheEnabled ? cache.get(cacheKey) : undefined;

      if (tokens == undefined) {
        tokens = parseTemplate(template, tags);
        isCacheEnabled && cache.set(cacheKey, tokens);
      }
      return tokens;
    };

    /**
        * High-level method that is used to render the given `template` with
        * the given `view`.
        *
        * The optional `partials` argument may be an object that contains the
        * names and templates of partials that are used in the template. It may
        * also be a function that is used to load partial templates on the fly
        * that takes a single argument: the name of the partial.
        *
        * If the optional `config` argument is given here, then it should be an
        * object with a `tags` attribute or an `escape` attribute or both.
        * If an array is passed, then it will be interpreted the same way as
        * a `tags` attribute on a `config` object.
        *
        * The `tags` attribute of a `config` object must be an array with two
        * string values: the opening and closing tags used in the template (e.g.
        * [ "<%", "%>" ]). The default is to mustache.tags.
        *
        * The `escape` attribute of a `config` object must be a function which
        * accepts a string as input and outputs a safely escaped string.
        * If an `escape` function is not provided, then an HTML-safe string
        * escaping function is used as the default.
        */
    Writer.prototype.render = function render(template, view, partials, config) {
      var tags = this.getConfigTags(config);
      var tokens = this.parse(template, tags);
      var context = view instanceof Context ? view : new Context(view, undefined);
      return this.renderTokens(tokens, context, partials, template, config);
    };

    /**
        * Low-level method that renders the given array of `tokens` using
        * the given `context` and `partials`.
        *
        * Note: The `originalTemplate` is only ever used to extract the portion
        * of the original template that was contained in a higher-order section.
        * If the template doesn't use higher-order sections, this argument may
        * be omitted.
        */
    Writer.prototype.renderTokens = function renderTokens(tokens, context, partials, originalTemplate, config) {
      var buffer = '';

      var token, symbol, value;
      for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
        value = undefined;
        token = tokens[i];
        symbol = token[0];

        if (symbol === '#') value = this.renderSection(token, context, partials, originalTemplate, config);else
        if (symbol === '^') value = this.renderInverted(token, context, partials, originalTemplate, config);else
        if (symbol === '>') value = this.renderPartial(token, context, partials, config);else
        if (symbol === '&') value = this.unescapedValue(token, context);else
        if (symbol === 'name') value = this.escapedValue(token, context, config);else
        if (symbol === 'text') value = this.rawValue(token);

        if (value !== undefined)
        buffer += value;
      }

      return buffer;
    };

    Writer.prototype.renderSection = function renderSection(token, context, partials, originalTemplate, config) {
      var self = this;
      var buffer = '';
      var value = context.lookup(token[1]);

      // This function is used to render an arbitrary template
      // in the current context by higher-order sections.
      function subRender(template) {
        return self.render(template, context, partials, config);
      }

      if (!value) return;

      if (isArray(value)) {
        for (var j = 0, valueLength = value.length; j < valueLength; ++j) {
          buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate, config);
        }
      } else if (typeof value === 'object' || typeof value === 'string' || typeof value === 'number') {
        buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate, config);
      } else if (isFunction(value)) {
        if (typeof originalTemplate !== 'string')
        throw new Error('Cannot use higher-order sections without the original template');

        // Extract the portion of the original template that the section contains.
        value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);

        if (value != null)
        buffer += value;
      } else {
        buffer += this.renderTokens(token[4], context, partials, originalTemplate, config);
      }
      return buffer;
    };

    Writer.prototype.renderInverted = function renderInverted(token, context, partials, originalTemplate, config) {
      var value = context.lookup(token[1]);

      // Use JavaScript's definition of falsy. Include empty arrays.
      // See https://github.com/janl/mustache.js/issues/186
      if (!value || isArray(value) && value.length === 0)
      return this.renderTokens(token[4], context, partials, originalTemplate, config);
    };

    Writer.prototype.indentPartial = function indentPartial(partial, indentation, lineHasNonSpace) {
      var filteredIndentation = indentation.replace(/[^ \t]/g, '');
      var partialByNl = partial.split('\n');
      for (var i = 0; i < partialByNl.length; i++) {
        if (partialByNl[i].length && (i > 0 || !lineHasNonSpace)) {
          partialByNl[i] = filteredIndentation + partialByNl[i];
        }
      }
      return partialByNl.join('\n');
    };

    Writer.prototype.renderPartial = function renderPartial(token, context, partials, config) {
      if (!partials) return;
      var tags = this.getConfigTags(config);

      var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
      if (value != null) {
        var lineHasNonSpace = token[6];
        var tagIndex = token[5];
        var indentation = token[4];
        var indentedValue = value;
        if (tagIndex == 0 && indentation) {
          indentedValue = this.indentPartial(value, indentation, lineHasNonSpace);
        }
        var tokens = this.parse(indentedValue, tags);
        return this.renderTokens(tokens, context, partials, indentedValue, config);
      }
    };

    Writer.prototype.unescapedValue = function unescapedValue(token, context) {
      var value = context.lookup(token[1]);
      if (value != null)
      return value;
    };

    Writer.prototype.escapedValue = function escapedValue(token, context, config) {
      var escape = this.getConfigEscape(config) || mustache.escape;
      var value = context.lookup(token[1]);
      if (value != null)
      return typeof value === 'number' && escape === mustache.escape ? String(value) : escape(value);
    };

    Writer.prototype.rawValue = function rawValue(token) {
      return token[1];
    };

    Writer.prototype.getConfigTags = function getConfigTags(config) {
      if (isArray(config)) {
        return config;
      } else
      if (config && typeof config === 'object') {
        return config.tags;
      } else
      {
        return undefined;
      }
    };

    Writer.prototype.getConfigEscape = function getConfigEscape(config) {
      if (config && typeof config === 'object' && !isArray(config)) {
        return config.escape;
      } else
      {
        return undefined;
      }
    };

    var mustache = {
      name: 'mustache.js',
      version: '4.2.0',
      tags: ['{{', '}}'],
      clearCache: undefined,
      escape: undefined,
      parse: undefined,
      render: undefined,
      Scanner: undefined,
      Context: undefined,
      Writer: undefined,
      /**
                          * Allows a user to override the default caching strategy, by providing an
                          * object with set, get and clear methods. This can also be used to disable
                          * the cache by setting it to the literal `undefined`.
                          */
      set templateCache(cache) {
        defaultWriter.templateCache = cache;
      },
      /**
          * Gets the default or overridden caching object from the default writer.
          */
      get templateCache() {
        return defaultWriter.templateCache;
      } };


    // All high-level mustache.* functions use this writer.
    var defaultWriter = new Writer();

    /**
                                       * Clears all cached templates in the default writer.
                                       */
    mustache.clearCache = function clearCache() {
      return defaultWriter.clearCache();
    };

    /**
        * Parses and caches the given template in the default writer and returns the
        * array of tokens it contains. Doing this ahead of time avoids the need to
        * parse templates on the fly as they are rendered.
        */
    mustache.parse = function parse(template, tags) {
      return defaultWriter.parse(template, tags);
    };

    /**
        * Renders the `template` with the given `view`, `partials`, and `config`
        * using the default writer.
        */
    mustache.render = function render(template, view, partials, config) {
      if (typeof template !== 'string') {
        throw new TypeError('Invalid template! Template should be a "string" ' +
        'but "' + typeStr(template) + '" was given as the first ' +
        'argument for mustache#render(template, view, partials)');
      }

      return defaultWriter.render(template, view, partials, config);
    };

    // Export the escaping function so that the user may override it.
    // See https://github.com/janl/mustache.js/issues/244
    mustache.escape = escapeHtml;

    // Export these mainly for testing, but also for advanced usage.
    mustache.Scanner = Scanner;
    mustache.Context = Context;
    mustache.Writer = Writer;

    return mustache;

  });
});

function helpersPart(_parent, _CONTEXT) {

  let _HELPERS_LIST = {};
  let _LOG_VERBOSITY = {};
  _LOG_VERBOSITY.ommit = [];
  _LOG_VERBOSITY.mode = [];
  if (typeof window === 'object')
  {
    if (!('_dsb_log_verbosity_ommit' in window))
    {
      window._dsb_log_verbosity_ommit = [];
    }
    _LOG_VERBOSITY.ommit = window._dsb_log_verbosity_ommit;
  }
  _HELPERS_LIST.tools = {};

  {
    let function_commonBrackets = function (i, stage, session, data, tmp_persist, return_processed, completed)
    {
      for (let ii = 0; ii < stage.length; ii++)
      {
        stage[ii] = _parent.run('tools', 'processMoustachedValuesFromJSON', [{ 'tmp_persist': tmp_persist, 'tmp': tmp_persist, 'session': session, '::last_return': return_processed, '::lr': return_processed }, stage[ii], null, true, false, true]);
        stage[ii] = _parent.run('tools', 'processMoustachedValuesFromJSON', [data, stage[ii], null, true, false, true]);
      }
      if (stage[0] == '::internal' || stage[0] == '::i')
      {
        switch (stage[1]) {

          case "tmp_persist":
          case "tmp":
            tmp_persist[stage[2]] = return_processed;
            _LOG('debug', 'tools.runBrackets', '[' + i + ']("' + stage[1] + '","' + stage[2] + '")', 'Ran...');
            completed = true;
            break;
          case "url_escape":
            return_processed = escape(stage[2]);
            _LOG('debug', 'tools.runBrackets', '[' + i + ']("' + stage[1] + '","' + stage[2] + '")', 'Ran...');
            completed = true;
            break;
          case "url_unescape":
            return_processed = unescape(stage[2]);
            _LOG('debug', 'tools.runBrackets', '[' + i + ']("' + stage[1] + '","' + stage[2] + '")', 'Ran...');
            completed = true;
            break;
          case "session_persist":
            if (typeof stage[2] === 'string')
            {
              if (stage[2] in session)
              {
                if (!Array.isArray(session[stage[2]]))
                {
                  let _tmp = session[stage[2]];
                  session[stage[2]] = [];
                  session[stage[2]].push(_tmp);
                }
                session[stage[2]].push(return_processed);
              } else

              {
                session[stage[2]] = return_processed;
              }
            } else

            {
              throw 'session_persist expects a string as the key!';
            }
            _LOG('debug', 'tools.runBrackets', '[' + i + ']("' + stage[1] + '","' + stage[2] + '") - Ran...', [return_processed, session[stage[2]]]);
            completed = true;
            break;
          case "set":
            _LOG('debug', 'tools.runBrackets', '[' + i + ']("' + stage[1] + '","' + stage[2] + '") - Ran...', [stage[2]]);
            return_processed = stage[2];
            completed = true;
            break;
          case "return":
            _LOG('debug', 'tools.runBrackets', '[' + i + ']("' + stage[1] + '","' + stage[2] + '") - Ran...', [stage[2]]);
            completed = {};
            completed.return = stage[2];
            break;}

      }
      return [i, stage, session, data, tmp_persist, return_processed, completed];
    };

    _HELPERS_LIST.tools.runBracketsAsync = async function (val, session = {}, data = {})
    {
      if (!(typeof session === 'object'))
      {
        session = {};
      }
      if (!(typeof data === 'object'))
      {
        data = {};
      }
      let text_object = ['unknown-helper', 'unknown-method', 'unknown-params'];
      text_object = JSON.parse(val.replaceAll("“", '"'));
      if (Array.isArray(text_object) && text_object.length > 0)
      {
        if (!Array.isArray(text_object[0]))
        {
          let _text_object = Array.from(text_object);
          text_object = [];
          text_object.push(_text_object);
        }
        let return_processed = '';
        let tmp_persist = {};
        _LOG('debug', 'tools.runBrackets', 'Processing que size "' + text_object.length + '"');
        for (let i = 0; i < text_object.length; i++)
        {
          let stage = [];
          try
          {
            stage = text_object[i];
            let completed = false;
            [i, stage, session, data, tmp_persist, return_processed, completed] = function_commonBrackets(i, stage, session, data, tmp_persist, return_processed, completed);
            if (completed)
            {
              if (typeof completed === 'object' && 'return' in completed)
              {
                return completed.return;
              }
            } else
            if (_parent.has(stage[0], stage[1]))
            {
              return_processed = await _parent.run(stage[0], stage[1], stage[2]);
              _LOG('debug', 'tools.runBrackets', '[' + i + ']("' + stage[0] + '","' + stage[1] + '")- Ran...', [stage, return_processed]);
            }
          }
          catch (ex)
          {
            _LOG('error', 'tools.runBrackets', '[' + i + '] - Failed to run', [stage, return_processed, ex]);
            throw ex;
          }
        }
        return return_processed;
      } else

      {
        throw 'runBrackets: text_object Mallformed.. not an array';
      }
    };
    _HELPERS_LIST.tools.runBrackets = function (val, session = {}, data = {})
    {
      if (!(typeof session === 'object'))
      {
        session = {};
      }
      if (!(typeof data === 'object'))
      {
        data = {};
      }
      let text_object = ['unknown-helper', 'unknown-method', 'unknown-params'];
      text_object = JSON.parse(val.replaceAll("“", '"'));
      if (Array.isArray(text_object) && text_object.length > 0)
      {
        if (!Array.isArray(text_object[0]))
        {
          let _text_object = Array.from(text_object);
          text_object = [];
          text_object.push(_text_object);
        }
        let return_processed = '';
        let tmp_persist = {};
        _LOG('debug', 'tools.runBrackets', 'Processing que size "' + text_object.length + '"');
        for (let i = 0; i < text_object.length; i++)
        {
          let stage = text_object[i];
          let completed = false;
          [i, stage, session, data, tmp_persist, return_processed, completed] = function_commonBrackets(i, stage, session, data, tmp_persist, return_processed, completed);
          if (completed)
          {
            if (typeof completed === 'object' && 'return' in completed)
            {
              return completed.return;
            }
          } else
          if (_parent.has(stage[0], stage[1]))
          {
            return_processed = _parent.run(stage[0], stage[1], stage[2]);
            _LOG('debug', 'tools.runBrackets', '[' + i + ']("' + stage[0] + '","' + stage[1] + '")', 'Ran...');
          }
        }
        return return_processed;
      } else

      {
        throw 'runBrackets: text_object Mallformed.. not an array';
      }
    };
  }
  _HELPERS_LIST.tools._skip_log = true;
  _HELPERS_LIST.tools.setLoggingMode = function (mode)
  {
    if (!Array.isArray(mode))
    {
      let _mode = mode;
      mode = [];
      mode.push(_mode);
    }
    _LOG_VERBOSITY.mode = mode;
  };
  _HELPERS_LIST.tools.logging = function (type, source, message, data = '')
  {
    if ('mode' in _LOG_VERBOSITY)
    {
      for (let amode of _LOG_VERBOSITY.mode)
      {
        if (amode.startsWith('!') && amode == '!' + type)
        {
          return;
        } else
        if (amode !== type)
        {
          return;
        }
      }
    }
    let _message = ' - ' + message;
    let prefix = source;
    if ('context_name' in _CONTEXT)
    {
      prefix = _CONTEXT.context_name + '::' + prefix;
    }
    _message = prefix + _message;

    if ('ommit' in _LOG_VERBOSITY)
    {
      if (_LOG_VERBOSITY.ommit.indexOf(type + '/' + prefix) > -1)
      {
        return;
      }
      if (_LOG_VERBOSITY.ommit.indexOf(type) > -1)
      {
        return;
      }
    }

    switch (type) {

      case "debug":
        console.debug(_message, data);
        break;
      case "warning":
        console.warn(_message, data);
        break;
      case "info":
        console.info(_message, data);
        break;
      case "error":
        console.error(_message, data);
        break;
      default:
        console.log(_message, data);}


  };
  _HELPERS_LIST.tools.delaySecAsync = async function (sec) {
    return new Promise(function (res)
    {
      _LOG('debug', 'Waiting for ' + sec + ' seconds.', sec * 1000);
      setTimeout(res, sec * 1000);
    });
  };
  _HELPERS_LIST.tools.pollSecAsync = async function (sec, testFunction, limit = 100) {
    if (typeof testFunction === 'function')
    {
      let count = 0;
      return new Promise(resolve => {
        const interval = setInterval(() => {
          if (testFunction()) {
            clearInterval(interval);
            resolve(true);
          }
          count++;
          if (count > limit)
          {
            clearInterval(interval);
            resolve(false);
          }
        }, sec * 1000);
      });
    }
  };
  _HELPERS_LIST.tools.sayHello = function (message) {
    _HELPERS_LIST._log('debug', 'sayHello', message);
  };
  _HELPERS_LIST.tools.getTrueForm = function (item, form = '')
  {
    if (typeof item === 'string')
    {
      try
      {
        item = JSON.parse(item);
      }
      catch (ex)
      {
        try
        {
          item = JSON.parse(atob(item));
        }
        catch (ex)
        {
          //ok
        }
      }
    }
    if (typeof form === 'string')
    {
      if (form.length > 0)
      {
        switch (form) {

          case "object":
            if (!typeof item === 'object')
            {
              item = { item };
            }
            break;
          case "array":
            if (!Array.isArray(item))
            {
              item = [item];
            }
            break;}

      }
    }
    return item;
  };
  _HELPERS_LIST.tools.extractFromDot = function (data, field)
  {
    if (typeof data === 'object')
    {
      if (!Array.isArray(field))
      {
        field = field.split('.');
      }
      let thisField = field[0];
      if (thisField in data)
      {
        if (field.length == 1)
        {
          return data[thisField];
        } else

        {
          field.shift();
          return _HELPERS_LIST.tools.extractFromDot(data[thisField], field);
        }
      }
    }
    throw 'Unknown';
  };

  _HELPERS_LIST.tools.createUUID = function ()
  {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,v = c == 'x' ? r : r & 0x3 | 0x8;
      return v.toString(16);
    });
  };

  _HELPERS_LIST.tools.mergeObjects = function (one, two)
  {
    if (Array.isArray(one) && Array.isArray(two))
    {
      return [...Array.from(one), ...Array.from(two)];
    } else
    if (typeof one === 'object' && typeof two === 'object')
    {
      return { ...JSON.parse(JSON.stringify(one)), ...JSON.parse(JSON.stringify(two)) };
    }
    throw 'Cannot merge!';
  };

  _HELPERS_LIST.tools.processMoustachedValuesFromJSON = function (data, _object, on_error = null, throw_on_missing = true, process_keys = false, keep_on_empty = false)
  {
    let object = '';
    try
    {
      object = JSON.parse(JSON.stringify(_object));
      if (!(typeof data === 'object'))
      {
        data = JSON.parse(data);
      }
    }
    catch (ex)
    {
      //Ok guess not.
      object = _object;
    }
    if (Array.isArray(object))
    {
      for (let i = 0; i < object.length; i++)
      {
        object[i] = _HELPERS_LIST.tools.processMoustachedValuesFromJSON(data, object[i], on_error, throw_on_missing, process_keys, keep_on_empty);
      }
    } else
    if (typeof object === 'object' && object !== null)
    {
      for (let a_key in object)
      {
        if (process_keys)
        {
          let new_key = _HELPERS_LIST.tools.processMoustachedValuesFromJSON(data, a_key);
          if (typeof new_key === 'string' && new_key.length > 0 && new_key !== a_key)
          {
            object[new_key] = JSON.parse(JSON.stringify(object[a_key]));
            delete object[a_key];
            a_key = new_key;
          }
        }
        object[a_key] = _HELPERS_LIST.tools.processMoustachedValuesFromJSON(data, object[a_key], on_error, throw_on_missing, process_keys, keep_on_empty);
      }
    } else

    {
      if (typeof object === 'string')
      {
        if (object.startsWith('{{'))
        {
          object = object.replace('{{', '');
          object = object.replace('}}', '');
          let processed_result = _HELPERS_LIST.tools.getValuesFromJSON(data, object, on_error, throw_on_missing);
          if ((processed_result === null || typeof processed_result === 'string' && processed_result.length == 0) && keep_on_empty)
          {
            return _object;
          }
          return processed_result;
        } else
        if (object.startsWith('{'))
        {
          object = object.replace('{', '');
          object = object.replace('}', '');
          let processed_result = _HELPERS_LIST.tools.getValuesFromJSON(data, object, on_error, throw_on_missing);
          if ((processed_result === null || typeof processed_result === 'string' && processed_result.length == 0) && keep_on_empty)
          {
            return _object;
          }
          return processed_result;
        } else
        if (object.startsWith('~{{'))
        ;
      }
    }
    return object;
  };

  _HELPERS_LIST.tools.explode = function (data, delimiter)
  {
    if (typeof data === 'string')
    {
      let delimiters = [];
      if (!Array.isArray(delimiter))
      {
        delimiters.push(delimiter);
      } else

      {
        delimiters = delimiter;
      }
      for (let a_delimiter of delimiters)
      {
        if (data.includes(a_delimiter))
        {
          return data.split(a_delimiter);
        }
      }
      return [data];
    } else
    if (Array.isArray(data) && data.length > 0 && !isNaN(delimiter))
    {
      let arr = Array.from(data);
      let result = [];
      for (let i = 0; i < arr.length; i += delimiter) {
        result.push(arr.slice(i, i + delimiter));
      }
      return result;
    }
    throw "Cannot explode";
  };

  _HELPERS_LIST.tools.split = function (array, end, start = 0) {
    if (typeof array === 'string' && typeof end === 'string' && isNaN(end))
    {
      return array.split(end)[0];
    } else
    if (Array.isArray(array) && array.length > 0)
    {
      let return_array = Array.from(array);
      if (isNaN(end) || end > array.length)
      {
        end = array.length;
      }
      if (isNaN(start) || start < 0)
      {
        start = 0;
      }
      return_array = return_array.slice(start, end);
      return return_array;
    }
    throw "Cannot split";
  };

  _HELPERS_LIST.tools.getValuesFromJSON = function (data, key, on_error = null, throw_on_missing = true, execute_functions = true)
  {
    let _function__recursiveGet = function (data, field, throw_on_missing) {
      //console.error('_getDataValue._function__recursiveGet...',data,field);

      let function_processValue = function (raw_data, field, throw_on_missing)
      {
        //console.error('_getDataValue._function__recursiveGet.function_processValue... Looking for '+field,raw_data);
        let this_data = [];
        if (!Array.isArray(raw_data))
        {
          this_data.push(raw_data);
        } else

        {
          this_data = raw_data;
        }

        if (!Array.isArray(field))
        {
          field = field.split('.');
        }
        let thisField = field[0];
        let results = [];
        for (let data of this_data)
        {
          let a_result = [];
          if (thisField in data)
          {
            if (field.length == 1)
            {
              //console.error('_getDataValue._function__recursiveGet.function_processValue... Found '+thisField,data[thisField]);
              if (execute_functions && typeof data[thisField] === 'function')
              {
                a_result.push(data[thisField]());
              } else

              {
                a_result.push(data[thisField]);
              }
            } else

            {
              field.shift();
              if (Array.isArray(data[thisField]))
              {
                if (data[thisField].length == 0)
                {
                  continue;
                }
              } else
              if (typeof data[thisField] !== 'object')
              {
                continue;
              }
              //console.error('_getDataValue._function__recursiveGet.function_processValue... Found '+thisField+' recursing',{'field':field,'data':data[thisField]});
              a_result.push(_function__recursiveGet(data[thisField], field, false));
            }
          }

          if (a_result.length > 0)
          {
            if (a_result.length == 1)
            {
              a_result = a_result[0];
            }
            results.push(a_result);
          }
        }

        //console.error('_getDataValue._function__recursiveGet.function_processValue... got: '+field,results);

        if (results.length > 0)
        {
          if (results.length == 1)
          {
            results = results[0];
          }
          return results;
        } else

        {
          if (throw_on_missing)
          {
            throw 'Unknown "' + field + '"';
          }
        }
      };

      return function_processValue(data, field, throw_on_missing);
    };
    try
    {
      if (typeof key === 'object')
      {
        let return_object = {};
        for (let key_target in key)
        {
          return_object[key_target] = _function__recursiveGet(data, key[key_target], throw_on_missing);
        }
        return return_object;
      } else

      {
        return _function__recursiveGet(data, key, throw_on_missing);
      }
    }
    catch (e)
    {
      if (typeof on_error === 'function')
      {
        return on_error(e);
      }
      return on_error;
    }
  };
  _HELPERS_LIST.html = {};
  _HELPERS_LIST.html.spinner = function (return_object = false)
  {
    let loadingElement = document.createElement('div');
    loadingElement.style = "position: relative;min-height: 100px;";
    loadingElement.innerHTML = `<svg class="dsb_spinner" width="34px" height="34px" viewBox="0 0 66 66" xmlns="http://www.w3c.org/2000/svg"><circle class="dsb_spinner_path" fill="none" stroke-width="4" stroke-linecap="round" cx="33" cy="33" r="30"></circle></svg>`;
    return return_object ? loadingElement : loadingElement.outerHTML;
  };

  _HELPERS_LIST.ui = {};
  _HELPERS_LIST.ui.open = function (target, element, atts, fallback)
  {
    let open_target = document.getElementById(target);
    if (open_target instanceof HTMLElement)
    {
      if (typeof element === 'string')
      {
        element = document.createElement(element);
        if (!(typeof atts === 'object'))
        {
          atts = { 'data': atts };
        }
        for (let an_att in atts)
        {
          element.setAttribute(an_att, atts[an_att]);
        }
      }
      if (element instanceof HTMLElement)
      {
        open_target.innerHTML = '';
        open_target.append(element);
      } else

      {
        throw 'Not a HTMLElement';
      }
    } else

    {
      if (typeof fallback === 'string')
      {
        window.open(fallback, '_blank');
        return;
      }
    }
  };

  {
    let _SESSION_DATA = {};
    let _SESSION_ONCHANGE = {};
    let _SESSION_LOADED = {};
    let _function_runWatched = function (key)
    {
      if (key in _SESSION_ONCHANGE && key in _SESSION_DATA)
      {
        for (let anAction of _SESSION_ONCHANGE[key])
        {
          if (typeof anAction === 'function')
          {
            anAction(_SESSION_DATA[key]);
          }
        }
      }
    };
    _HELPERS_LIST.session_by_id = {
      get: async function (id, key, on_missing = false, on_error = false, timeout = 30000)
      {
        try
        {
          if (!(id in _SESSION_LOADED))
          {

            _SESSION_LOADED[id] = document.querySelector('[data-dsb-session_id="' + id + '"]');
            if (!(_SESSION_LOADED[id] instanceof HTMLElement))
            {
              await _HELPERS_LIST.tools.pollSecAsync('3', function () {
                _SESSION_LOADED[id] = document.querySelector('[data-dsb-session_id="' + id + '"]');
                if (_SESSION_LOADED[id] instanceof HTMLElement)
                {
                  return true;
                }
                return false;
              }, 10);
            }
          }
          if (_SESSION_LOADED[id] instanceof HTMLElement)
          {
            let dsb_ready = false;
            if ('dsb' in _SESSION_LOADED[id] && typeof _SESSION_LOADED[id].dsb === 'object' && _SESSION_LOADED[id].dsb.helpers.has('session', 'get'))
            {
              dsb_ready = true;
            } else

            {
              dsb_ready = await _HELPERS_LIST.tools.pollSecAsync('3', function () {
                if ('dsb' in _SESSION_LOADED[id] && typeof _SESSION_LOADED[id].dsb === 'object')
                {
                  if (_SESSION_LOADED[id].dsb.helpers.has('session', 'get'))
                  {
                    return true;
                  }
                }
                return false;
              }, 10);
            }
            if (dsb_ready)
            {
              if (_SESSION_LOADED[id].dsb.helpers.run('session', 'has', [key]))
              {
                return _SESSION_LOADED[id].dsb.helpers.run('session', 'get', [key, on_error]);
              } else

              {
                return new Promise(async function (resolve, reject) {
                  _SESSION_LOADED[id].dsb.helpers.run('session', 'watch', [key, function (returnable)
                  {
                    resolve(returnable);
                  }]);

                  if (timeout > 0)
                  {
                    setTimeout(() => reject(false), timeout);
                  }
                });
              }
            }
          } else

          {
            delete _SESSION_LOADED[id];
          }
          return false;
        }
        catch (ex)
        {
          return false;
        }
      } };


    _HELPERS_LIST.session = {
      has: function (key)
      {
        try
        {
          _HELPERS_LIST.tools.extractFromDot(_SESSION_DATA, key);
          return true;
        }
        catch (ex)
        {
          return false;
        }
      },
      get: function (key, on_error = false)
      {
        try
        {
          if (this.has(key))
          {
            return _HELPERS_LIST.tools.extractFromDot(_SESSION_DATA, key);
          }
          throw 'Cannot find ' + key;
        }
        catch (ex)
        {
          if (typeof on_error === 'function')
          {
            return on_error(ex);
          } else
          if (typeof on_error === 'string')
          {
            return on_error;
          } else

          {
            throw ex;
          }
        }
      },
      set: function (key, value)
      {
        _SESSION_DATA[key] = value;
        _function_runWatched(key);
        return true;
      },
      add: function (key, value)
      {
        if (key in _SESSION_DATA)
        {
          switch (typeof _SESSION_DATA[key]) {

            case "object":
              if (isArray(_SESSION_DATA[key]))
              {
                _SESSION_DATA[key].push(value);
                _function_runWatched(key);
                return true;
              } else

              {
                if (typeof value === 'object')
                {
                  _SESSION_DATA[key] = { ..._SESSION_DATA[key], ...value };
                  _function_runWatched(key);
                  return true;
                }
              }
              break;
            default:
              _SESSION_DATA[key] = _SESSION_DATA[key] + value;
              _function_runWatched(key);
              return true;}

        } else

        {
          return this.set(key, value);
        }
        return true;
      },
      watch: function (key, callback)
      {
        if (typeof callback === 'function')
        {
          if (!(key in _SESSION_ONCHANGE))
          {
            _SESSION_ONCHANGE[key] = [];
          }
          _SESSION_ONCHANGE[key].push(callback);
          _function_runWatched(key);
        }
      } };

  }

  let _LOG = function (type, source, message, data = '')
  {
    source = '(part-helpers)' + source;
    _parent.run('tools', 'logging', [type, source, message, data]);
  };

  _parent.has = function (helper, method, throw_mode = false) {
    try
    {
      if (helper.length > 0 && method.length > 0 && !method.startsWith('_'))
      {
        if (helper in _HELPERS_LIST && typeof _HELPERS_LIST[helper] === 'object' && method in _HELPERS_LIST[helper])
        {
          if (typeof _HELPERS_LIST[helper][method] === 'function')
          {
            return true;
          } else

          {
            throw '_HELPERS_LIST[' + helper + '][' + method + '] === ' + typeof _HELPERS_LIST[helper][method];
          }
        }
      }
    }
    catch (ex)
    {
      if (throw_mode || helper === 'tools')
      {
        throw ex;
      } else

      {
        _LOG('error', 'has', 'Has failed!', { 'ex': ex, 'helper': helper, 'method': method, 'throw_mode': throw_mode });
      }
    }
    return false;
  };

  _parent.list = function ()
  {
    return Object.keys(_HELPERS_LIST);
  };

  _parent.run = function (helper, method, params, _default = null, error_mode = 'log')
  {
    try
    {
      if (_parent.has(helper, method))
      {
        if (!Array.isArray(params))
        {
          params = [params];
        }
        if (helper !== 'tools')
        {
          _LOG('debug', 'run', 'Found ' + helper + '.' + method + '()', { 'helper': helper, 'method': method, 'params': params });
        }
        return _HELPERS_LIST[helper][method](...params);
      } else

      {
        if (helper !== 'tools')
        {
          _LOG('warning', 'run', 'Cannot find ' + helper + '.' + method + '()!', { 'helper': helper, 'method': method, 'params': params });
        }
        if (typeof _default === 'function')
        {
          return _default();
        } else

        {
          return _default;
        }
      }
    }
    catch (ex)
    {
      if (error_mode == 'throw' || helper == 'tools')
      {
        throw ex;
      } else
      if (typeof error_mode === 'function')
      {
        error_mode({ 'ex': ex, 'helper': helper, 'method': method, 'params': params, 'error_mode': error_mode });
      } else
      if (error_mode !== 'silent')
      {
        _LOG('error', 'run', 'Run failed!', { 'ex': ex, 'helper': helper, 'method': method, 'params': params, 'error_mode': error_mode });
      }
    }
  };

  _parent.add = function (helper, method, this_function)
  {
    if (!(typeof _HELPERS_LIST === 'object'))
    {
      _HELPERS_LIST = {};
    }

    if (typeof helper === 'string' && helper.length > 0 && typeof method === 'string' && method.length > 0 && typeof this_function === 'function')
    {
      try
      {
        _LOG('debug', 'add', 'Adding helper[' + helper + '][' + method + ']()...');
        if (!(helper in _HELPERS_LIST))
        {
          _HELPERS_LIST[helper] = {};
        }
        _HELPERS_LIST[helper][method] = this_function;
      }
      catch (ex)
      {
        _LOG('error', 'add', 'Adding helper ' + helper + '.' + method + ' failed!', ex);
      }
    } else

    {
      _LOG('warning', 'add', 'Mallformed! helper="' + helper + '",method="' + method + '" or supplied function isnt a function.');
    }
    return false;
  };

  _parent.runUrlAsync = async function (url, _default = null, error_mode = 'log')
  {
    try
    {
      if (typeof url === 'string')
      {
        let split_point = url.indexOf('//');
        if (split_point > 0)
        {
          let path = url.substring(split_point + 2);
          split_point = path.indexOf('/');
          if (split_point > 0)
          {
            let target = path.substring(0, split_point);
            let params = path.substring(split_point + 1);
            params = params.replaceAll("'", '"');
            target = target.split('.');
            if (target.length == 2)
            {
              return await _parent.run(target[0], target[1], _HELPERS_LIST.tools.getTrueForm(params, 'array'), _default, error_mode);
            } else

            {
              throw 'Missing helper name or method format: "helper_name.method"';
            }
          } else

          {
            throw 'Cannot find / in path="' + path + '"';
          }
        } else

        {
          throw 'Cannot find // in url="' + url + '"';
        }
      } else

      {
        throw "url is not a string";
      }
    }
    catch (ex)
    {
      if (error_mode == 'throw')
      {
        throw ex;
      } else
      if (error_mode !== 'silent')
      {
        _LOG('error', 'runUrlAsync', 'runUrlAsync failed!', { 'ex': ex, 'url': url, '_default': _default, 'error_mode': error_mode });
      }
    }
    return _default;
  };
}

function filtersPart(_parent, _CONTEXT) {

  let _FILTERS = {};
  _parent.has = function (filter)
  {
    if (typeof filter === 'string' && filter.length > 0 && filter in _FILTERS && typeof _FILTERS[filter] === 'function')
    {
      return true;
    }
    return false;
  };

  _parent.apply = function (filter, params)
  {
    if (_parent.has(filter))
    {
      return _FILTERS[filter](...params);
    } else

    {
      return params;
    }
  };

  _parent.add = function (filter, filter_function)
  {
    if (typeof filter_function === 'function')
    {
      _FILTERS[filter] = filter_function;
    } else

    {
      throw 'Not a function';
    }
  };
}

function hooksPart(_parent, _HELPERS) {

  if (!(typeof _parent === 'object'))
  {
    throw 'part-hooks::_parent is not an object';
  }

  for (let require_method of ['has', 'run', 'add'])
  {
    if (require_method in _parent)
    {
      throw 'part-hooks::_parent.' + require_method + ' already exists';
    }
  }

  let _LOG = function (type, source, message, data = '')
  {
    source = 'hook-process.' + source;
    if (typeof _HELPERS === 'object' && _HELPERS !== null && 'has' in _HELPERS && _HELPERS.has('tools', 'logging'))
    {
      _HELPERS.run('tools', 'logging', [type, source, message, data]);
    } else

    {
      let _message = source + '- ' + message;
      switch (type) {

        case "debug":
          console.debug(_message, data);
          break;
        case "warning":
          console.warn(_message, data);
        case "info":
          console.info(_message, data);
          break;
        case "error":
          console.error(_message, data);
          break;
        default:
          console.log(_message, data);}

    }
  };

  let _HOOKS = {};

  _parent.has = function (hook)
  {
    if (hook in _HOOKS && Array.isArray(_HOOKS[hook]))
    {
      return true;
    }
    return false;
  };

  _parent.run = function (hook, params = [])
  {
    if (_parent.has(hook))
    {
      if (Array.isArray(_HOOKS[hook]))
      {
        for (let i = 0; i < _HOOKS[hook].length; i++)
        {
          if (typeof _HOOKS[hook][i] === 'function')
          {
            _HOOKS[hook][i](...params);
          } else

          {
            _LOG('warning', 'run', '_HOOKS[' + hook + '][' + i + '] hook is not a function!');
          }
        }
      } else

      {
        _LOG('warning', 'run', '_HOOKS[' + hook + '] is not an array!');
      }
    }
  };

  _parent.add = function (hook, hook_function)
  {
    if (typeof hook === 'string' && hook.length > 0 && typeof hook_function === 'function')
    {
      if (!(hook in _HOOKS))
      {
        _HOOKS[hook] = [];
      }
      _HOOKS[hook].push(hook_function);
    } else

    {
      throw 'Not a function';
    }
  };

}

function toolsPart(_parent, _CONTEXT) {


  _parent._createUUID = function ()
  {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,v = c == 'x' ? r : r & 0x3 | 0x8;
      return v.toString(16);
    });
  };

}

function statePart(_parent, _CONTEXT) {

  let _STATE = {};
  let _STATE_actions = {};
  _parent.is = function (state)
  {
    if (typeof state === 'string' && state.length > 0 && _STATE === state)
    {
      return true;
    }
    return false;
  };

  _parent.set = function (state)
  {
    if (_STATE in _STATE_actions && typeof _STATE_actions[_STATE].off === 'function')
    {
      _STATE_actions[_STATE].off();
    }
    _STATE = state;
    if (state in _STATE_actions && typeof _STATE_actions[state].on === 'function')
    {
      _STATE_actions[state].on();
    }
  };

  _parent.get = function (state)
  {
    return _STATE;
  };

  _parent.addAction = function (state, function_on = false, function_off = false)
  {
    if (typeof function_on === 'function')
    {
      _STATE_actions[state] = {};
      _STATE_actions[state].on = function_on;
      if (typeof function_off === 'function')
      {
        _STATE_actions[state].off = function_off;
      } else

      {
        _STATE_actions[state].off = false;
      }
    } else

    {
      throw 'Not a function';
    }
  };
}

var _CSS = ":host{--fullheight:100%;--fullwidth:100%;--font-base-font-family:'Roboto',sans-serif;--font-heading-font-family:'Work Sans',sans-serif;--font-color-default:var(--color-dark-grey);--font-x-bold:900;--font-bold:700;--font-medium:600;--font-semibold:500;--font-normal:400;--font-light:300;--font-xx-large-font-size:36px;--font-x-large-font-size:20px;--font-large-font-size:18px;--font-base-font-size:16px;--font-small-font-size:14px;--font-tiny-font-size:12px;--font-x-tiny-font-size:10px;--base-line-height:24px;--large-line-height:26px;--base-border-radius:2px;--base-spacing:44px;--small-spacing:var(--base-line-height);--big-spacing:64px;--default-padding:32px;--base-z-index:0;--input-padding:16px;--large-image-circle:185px;--medium-image-circle:155px;--small-image-circle:80px;--colour-red:#d2222a;--colour-white:#FFF;--colour-error:var(--colour-red);--colour-shadow:#000;--colour-black:#000;--colour-green:#0CCE6B;--colour-red-fade:color-mix(in hsl,var(--colour-red),transparent 87%);--colour-green-fade:color-mix(in hsl,var(--colour-green),transparent 87%);--colour-white-fade:olor-mix(in hsl,var(--colour-white),transparent 80%);--colour-green-light:#dff9ec;--colour-red-light:#f9e2e3;--colour-yellow:#fcdc18;--colour-yellow-button:#fbda38;--colour-yellow-grad:linear-gradient(to top, #f8d300, #ffe600);--colour-yellow-save:#FFF05A;--colour-yellow-fade:rgba(var(--colour-yellow), 0.13);--colour-green-0:#1d7f35;--colour-green-2:#0CCE6B;--colour-green-4:#bed389;--colour-light-green-0:#a8cd4c;--colour-light-green-4:#a0c349;--colour-blue:#567fa0;--colour-blue-glow:#6EA6E7;--colour-blue-button:#476279;--colour-blue-rain:#199CD7;--colour-blue-light:#DAEFF8;--colour-blue-advert:#E5F6FD;--colour-blue-hover:#006baa;--colour-red-0:#CC0201;--colour-red-1:#D3221A;--colour-red-2:#C20F25;--colour-red-3:#F5D7D7;--colour-red-4:#D2232A;--colour-gray-0:#F2F2F2;--colour-gray-1:#D6D6D6;--colour-gray-2:#F5F5F5;--colour-gray-3:#E6EEF5;--colour-gray-4:#fbfbfb;--colour-gray-5:#dcdcdc;--colour-gray-6:#666666;--colour-gray-7:#555555;--colour-gray-8:#9b9b9b;--colour-gray-9:#d8d8d8;--colour-gray-10:#F6F6F6;--colour-gray-11:#797979;--colour-gray-12:#1E1E1E;--colour-gray-13:#EAEAEA;--colour-gray-14:#D6D7D8;--colour-gray-15:#F3F3F3;--colour-gray-16:#78797B;--colour-gray-17:#9E9E9E;--colour-gray-18:#373737;--colour-gray-19:#d2d2d2;--colour-gray-darkest-grey:#404040;--colour-gray-lightest-grey:#fdfdfd;--color-dark-grey:#4A4A4A;--color-dark-grey-light:#F1F1F1;--color-grey-light:#F9F9F9;--category-colour-default:#fcdc18;--category-colour-arable:#D5691B;--category-colour-livestock:#1AB9AB;--category-colour-lifestyle:#BA2F89;--category-colour-farm-life:var(--category-colour-lifestyle);--category-colour-business:#CF2531;--category-colour-machinery:#189CD8;--category-colour-advertiser:#106399;--category-colour-services:#CF2531;--category-colour-news:var(--category-colour-dark-grey);--category-colour-default-light:#F9F9F9;--category-colour-arable-light:#FEF1E8;--category-colour-livestock-light:#DDF5F3;--category-colour-lifestyle-light:#F8EAF3;--category-colour-business-light:#fbe9ea;--category-colour-machinery-light:#D6EDF8;--category-colour-advertiser-light:#F2F6FA;--category-colour-services-light:#fef1a3;--category-colour-news-light:var(--gray-10);--category-colour-default-x-light:#F9F9F9;--category-colour-arable-x-light:#FDF7F3;--category-colour-livestock-x-light:#F3FBFB;--category-colour-lifestyle-x-light:#F9F9F9;--category-colour-business-x-light:#FDF4F4;--category-colour-machinery-x-light:#F9F9F9;--category-colour-advertiser-x-light:#F9F9F9;--category-colour-services-x-light:#fffadd;--category-colour-news-x-light:--gray-10;--category-colour-advertiser-reduced:rgba( #106399, 0.12);--category-colour-services-reduced:rgba( #fcdc18, 0.12);--category-colour-news-reduced:rgba( var(--category-colour-dark-grey), 0.12);--category-colour-grey-section:#D2222A;--category-colour-grey-light-section:var(--category-colour-dark-grey-light);--color-background-grey:var(--colour-gray-0);--color-base-border:var(--colour-gray-5)}@supports (-webkit-touch-callout:none){:host{--fullheight:-webkit-fill-available}}@supports (min-height:env(safe-area-inset-bottom)){:host{--fullheight:calc(100vh - env(safe-area-inset-bottom, 0) - env(safe-area-inset-top, 0))}}@supports (min-width:env(safe-area-inset-right)){:host{--fullwidth:calc(100vw - env(safe-area-inset-right, 0))}}:host{color:var(--font-color-default);font-family:var(--font-base-font-family)}:host body,:host h1,:host h2,:host h3,:host h4,:host h5,:host h6,:host p{color:var(--font-color-default);font-family:var(--font-base-font-family)}:host .dsb_spinner{animation:dsb_spinner_rotator 2s linear infinite;width:64px;height:64px;position:absolute;top:50%;left:50%;transform:translateX(-50%) translateY(-50%);z-index:12}:host .dsb_spinner_path{stroke-dasharray:187;stroke-dashoffset:0;transform-origin:center;animation:dsb_spinner_dash 2s ease-in-out infinite,dsb_spinner_colors 8s ease-in-out infinite}@keyframes dsb_spinner_rotator{0%{transform:translateX(-50%) translateY(-50%) rotate(0)}to{transform:translateX(-50%) translateY(-50%) rotate(270deg)}}@keyframes dsb_spinner_colors{0%{stroke:#cc0201}25%{stroke:#cc0201}to{stroke:#cc0201}}@keyframes dsb_spinner_dash{0%{stroke-dashoffset:187}50%{stroke-dashoffset:47;transform:rotate(135deg)}to{stroke-dashoffset:187;transform:rotate(450deg)}}:host .icon-info{display:inline-block;width:100%;text-align:left;padding:10px;padding-left:30px;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20height%3D%2724px%27%20viewBox%3D%270%20-960%20960%20960%27%20width%3D%2724px%27%20fill%3D%27%235f6368%27%3E%3Cpath%20d%3D%27M440-280h80v-240h-80v240Zm40-320q17%200%2028.5-11.5T520-640q0-17-11.5-28.5T480-680q-17%200-28.5%2011.5T440-640q0%2017%2011.5%2028.5T480-600Zm0%20520q-83%200-156-31.5T197-197q-54-54-85.5-127T80-480q0-83%2031.5-156T197-763q54-54%20127-85.5T480-880q83%200%20156%2031.5T763-763q54%2054%2085.5%20127T880-480q0%2083-31.5%20156T763-197q-54%2054-127%2085.5T480-80Z%27%2F%3E%3C%2Fsvg%3E);background-repeat:no-repeat;background-position:4px}\r\n/*# sourceMappingURL=HTMLDsbElement.min.css.map */";

class HTMLDsbElement extends HTMLElement {


  constructor(_settings = {})
  {
    super();
    if (!(typeof _settings === 'object'))
    {
      _settings = {};
    }
    this.dsb = {};
    this.dsb._ = { '_settings': _settings };
    this.dsb.state = false;
    this._settings = false;
    this.context_name = 'HTMLDsbElement';
    if ('component_name' in this.dsb._._settings)
    {
      console.log('HTMLDsbElement Init ' + this.dsb._._settings.component_name + '...');
      this.context_name = this.context_name + '/' + this.dsb._._settings.component_name;
    }
    this._context_name = this.context_name;
  }

  set debug(newValue)
  {
    this.setAttribute('debug', newValue);
    if (this.dsb.helpers.has('tools', 'setLoggingMode'))
    {
      this.dsb.helpers.run('tools', 'setLoggingMode', [newValue]);
    }
  }

  set data(newValue)
  {
    this.setAttribute('data', newValue);
    this._data = false;
  }

  get data()
  {
    return this._data;
  }

  _refreshContext()
  {
    let alias = this.getAttribute('alias');
    if (typeof alias == 'string' && alias.length > 0)
    {
      this.context_name = '[' + this.getAttribute('alias') + ']' + this._context_name;
    } else

    {
      this.context_name = this._context_name;
    }
  }
  /**
      async _processTemplateDataAttr()
      {
        let _this = this;
        if(this.dsb.helpers.has('process','template'))
        {
          let innerHTML_template = this.dsb.helpers.run('session','get',['templates.innerHTML']);
          if(innerHTML_template instanceof HTMLTemplateElement)
          {
            let processed_template = this.dsb.helpers.run('process','template',[innerHTML_template,this.data]);
            if(processed_template instanceof HTMLElement || processed_template instanceof DocumentFragment )
            {
              this.dsb.element.append(processed_template);
              this.dsb.state.set('templated');
            }
            else
            {
              this.dsb.log('error','_processTemplateDataAttr','Problem processing template for innerHTML.',processed_template);
            }
          }
          else
          {
            this.dsb.log('debug','_processTemplateDataAttr','No template for innerHTML found.',innerHTML_template);
          }
        }
    
        if(this.dsb.element instanceof HTMLElement && this.dsb.element.querySelector('[data-dsb-template]')!=null)
        {
          let fragments = this.dsb.element.querySelectorAll('[data-dsb-template]');
          fragments.forEach(element => {
            let expected_template_name = element.getAttribute('data-dsb-template');
            let expected_template = _this.dsb.helpers.run('session','get',['templates.'+expected_template_name]);
            if(!(expected_template instanceof HTMLTemplateElement) && _this.dsb.helpers.has('process','template.GetFromPath'))
            {
              let imported_template = _this.dsb.helpers.run('process','template.GetFromPath',[expected_template_name,false]);
              if(imported_template instanceof HTMLTemplateElement)
              {
                _this.dsb.helpers.run('session','set',['templates.'+expected_template_name,imported_template]);
                expected_template = imported_template;
              }
              else
              {
                expected_template=false;
              }
            }
    
            if(expected_template instanceof HTMLTemplateElement)
            {
              let template_result = _this.dsb.helpers.run('process','template',[expected_template,{'innerHTML':element.innerHTML,'target':element}]);
    
              if(template_result==='complete')
              {
                this.dsb.log('debug','_processTemplateDataAttr','Ok, processed and added new shadowTemplate');
              }
              else if(template_result instanceof HTMLElement)
              {
                element.innerHTML=template_result.innerHTML;
              }
              else
              {
                throw 'Template "'+expected_template_name+'" failed!';
              }
            }
          });
        }
      }
    */
  /**
         async _getProcessedData()
         {
           if(typeof this._data !== 'object')
           {
             this._data = this.getAttribute('data');
       
             if(typeof this._data !== 'object')
             {
               try
               {
                 this._data = JSON.parse(this._data);
               }
               catch(ex)
               {
                 try
                 {
                   this._data = JSON.parse(atob(this._data));
                 }
                 catch(ex)
                 {
                   // Ok data is just data
                 }
               }
             }
       
             if(this._data==null)
             {
               this._data=this.getAttribute('data');
             }
             if(this.dsb.hooks.has('pre_process_data'))
             {
               await this.dsb.hooks.run('pre_process_data',this._data);
             }
             if(typeof this._data === 'string')
             {
               if(this._data.startsWith('helper://'))
               {
                 this._data=await this.dsb.helpers.runUrlAsync(this._data,false);
                 if(typeof this._data === 'object' && this._data!== null && 'data' in this._data)
                 {
                   this._data=this._data.data;
                 }
               }
               else if(this._data.startsWith('brackets://'))
               {
                 if(this.dsb.helpers.has('tools','runBracketsAsync'))
                 {
                   try
                   {
                     this._data = await this.dsb.helpers.run('tools','runBracketsAsync',[this._data.replace('brackets://','').replaceAll("'",'"'),{},this._data]);
                   }
                   catch(ex)
                   {
                     throw {"error":"Failed to process brackets","message":ex};
                   }
                 }
                 else
                 {
                   throw 'runBracketsAsync Missing!'
                 }
               }
               else if((this._data.startsWith('http://') || this._data.startsWith('https://')) && this.dsb.helpers.has('fetch','getAsync'))
               {
                 this._data=await this.dsb.helpers.run('fetch','getAsync',[this._data]);
               }
               else if(this._data.startsWith('#') && this.dsb.helpers.has('process','comment'))
               {
                 let comment_data = await this.dsb.helpers.run('process','comment',[this.dsb.element,'data']);
                 this.dsb.log('debug','_getProcessedData','Checking for comment data...',comment_data);
                 if(comment_data!==null && typeof comment_data === 'object')
                 {
                   let hash='';
                   if(this.dsb.helpers.has('process','hash'))
                   {
                     hash=this.dsb.helpers.run('process','hash',[this._data,{},'object']);
                   }
                   this.dsb.log('debug','_getProcessedData','Found comment data, checking hash...',hash);
                   if(this.dsb.helpers.has('process','data'))
                   {
                     comment_data = this.dsb.helpers.run('process','data',[comment_data,hash, 'ommit']);
                   }
                   this._data=comment_data;
                 }
                 if(this.dsb.helpers.has('tools','runBracketsAsync'))
                 {
                   let comment_brackets = await this.dsb.helpers.run('process','comment',[this.dsb.element,'brackets',false]);
                   this.dsb.log('debug','_getProcessedData','Checking for brackets comment data...',comment_brackets);
                   if(comment_brackets!==null && typeof comment_brackets === 'string')
                   {
                     this._data = await this.dsb.helpers.run('tools','runBracketsAsync',[comment_brackets,{},this._data]);
                   }
                 }
               }
               else
               {
                /// ummm... ok
                 this._data={};
               }
             }
             if(this.dsb.hooks.has('post_process_data'))
             {
               await this.dsb.hooks.run('post_process_data',this._data);
             }
             if(typeof this._data !== 'object')
             {
               this._data={};
             }
           }
           this.dsb.log('debug','_getProcessedData','Processed data...',this._data);
           return this._data;
         }
       */
  /**
          async _getProcessedSettings()
            {
              let _this = this;
              if(!(typeof this._settings === 'object'))
              {
                let settings =  this.getAttribute('settings');
                if(typeof settings !== 'object')
                {
                  try
                  {
                    settings = JSON.parse(settings);
                  }
                  catch(ex)
                  {
                    try
                    {
                    settings = JSON.parse(atob(settings));
                    }
                    catch(ex)
                    {
                      settings=null
                    }
                  }
                }
          
                if(settings==null)
                {
                  settings={};
                }
          
                if('helpers' in settings)
                {
                  let helpers_type=typeof settings.helpers;
                  let new_helper={};
                  switch(helpers_type)
                  {
                    case "function":
                      new_helper=settings.helpers();
                      break;
                    case "object":
                      new_helper=settings.helpers;
                      break;
                    case "string":
                      let _global = (typeof window !== 'undefined'?window:(typeof global !== 'undefined'?global:null));
                      let wait_count = ('helper_wait_count' in settings?settings.helper_wait_count:20);
                      let check_for_hepler = function (sec)
                      {
                        if(_global != null && typeof _global === 'object' && settings.helpers in _global)
                        {
                          new_helper = _global[settings.helpers];
                          _this.dsb.log('debug','settings','Found helper "'+settings.helpers+'"');
                        }
                        else
                        {
                          if(wait_count>0)
                          {
                            wait_count--;
                            _this.dsb.log('debug','settings','Cannot find global object for helper "'+settings.helpers+'"... waiting '+sec+'s and checking again, '+wait_count+' more times... ');
                            setTimeout(function(){
                              check_for_hepler(sec);
                            }, (sec*1000));
                          }
                          else
                          {
                            _this.dsb.log('error','settings','Cannot find global object for helper "'+settings.helpers+'"... timedout after '+sec+'s x '+('helper_wait_count' in settings?settings.helper_wait_count:20)+' times and checking again... ');
                          }
                        }
                      }
                      check_for_hepler(('helper_wait' in settings?settings.helper_wait:2));
                      break;
                    default:
                      this.dsb.log('warning','settings','Unknown helpers type "'+helpers_type+'"');
                      break;
                  }
                  try
                  {
                    if(typeof new_helper === 'object')
                    {
                      if(('createContext' in new_helper) && typeof new_helper.createContext === 'function')
                      {
                        new_helper = new_helper.createContext(this.context_name);
                      }
                      else
                      {
                        this.dsb.log('warning','settings','No helper.createContext found!');
                      }
                      for(let required_function in  this.dsb.helpers)
                      {
                        if(!(required_function in new_helper) || typeof new_helper[required_function] !== 'function')
                        {
                          throw 'Missing required function "'+required_function+'"';
                        }
                      }
                      this.dsb.helpers=new_helper;
                    }
                    else
                    {
                      throw 'Not an object';
                    }
                  }
                  catch(ex)
                  {
                    this.dsb.log('error','settings','settings.helpers "'+settings.helpers+'" is not a valid helper: '+ex,{new_helper});
                  }
          
                }
                this._settings=settings;
              }
              this.dsb.log('debug','_getProcessedSettings','Processed settings...',this._settings);
              return this._settings;
            }
          */

  set settings(newValue)
  {
    this.setAttribute('settings', newValue);
    this._settings = false;
  }

  get settings()
  {
    return this._settings;
  }


  connectedCallback() {
    try
    {
      let _this = this;

      if (!this.dsb.state)
      {
        try
        {
          this._refreshContext();
          this.dsb.state = {};
          this.dsb.helpers = {};
          this.dsb.helpers.has = function (params)
          {
            return false;
          };
          this.dsb.filters = {};
          this.dsb.hooks = {};
          this.dsb.log = function (type, source, message, data = '')
          {
            if (_this.dsb.helpers.has('tools', 'logging'))
            {
              _this.dsb.helpers.run('tools', 'logging', [type, source, message, data]);
            } else

            {
              let _message = _this.context_name + '::' + source + '- ' + message;
              switch (type) {

                case "debug":
                  console.debug(_message, data);
                  break;
                case "warning":
                  console.warn(_message, data);
                  break;
                case "error":
                  console.error(_message, data);
                  break;
                default:
                  console.log(_message, data);}

            }
          };
          statePart(this.dsb.state);
          this.dsb.state.set('init-parts');
          filtersPart(this.dsb.filters);
          helpersPart(this.dsb.helpers, this);
          hooksPart(this.dsb.hooks, this.dsb.helpers);
          toolsPart(this, this.dsb._._settings);
          if ('_constructorBuildHelpers' in _this)
          {
            _this._constructorBuildHelpers(_this.dsb);
          }

          _this.dsb.hooks.add('onFatalError', function (type, component, ex) {
            if (!(component instanceof HTMLElement))
            {
              component = _this;
            }
            _this.dsb.state.set('FatalError');
            _this.dsb.log('error', 'onFatalError', ex);
            component.innerHTML = '<div class="error" style="font-style:italic;padding:10px;">A problem seems to have occured...<br/>Please try again later.</div>';

          });

          let loadingElement = false;

          let function___initHTML = function ()
          {
            _this.dsb.element = _this.innerHTML;
            _this.dsb.element_templated = false;
            _this.dsb.element_original = _this.innerHTML;

            let function__isInShadow = function (node)
            {
              for (; node; node = node.parentNode) {
                if (node.toString() === "[object ShadowRoot]") {
                  return true;
                }
              }
              return false;
            };

            _this.dsb.state.addAction('loading', function () {
              let show_loader = false;
              if ('data-dsb_loader' in _this)
              {
                show_loader = _this['data-dsb_show_loader'];
                if (show_loader === 'no' || show_loader === 'off')
                {
                  show_loader = false;
                }
              }
              if (show_loader)
              {
                if (_this.dsb.helpers.has('html', 'spinner'))
                {
                  loadingElement = _this.dsb.helpers.run('html', 'spinner', [true]);
                  _this.dsb.element.innerHTML = '';
                  _this.dsb.element.append(loadingElement);
                } else

                {
                  _this.dsb.element.innerHTML = 'Loading...';
                }
              }
            }, function () {
              if (loadingElement instanceof HTMLElement)
              {
                loadingElement.remove();
              }
            });

            if (_this.dsb.helpers.has('process', 'template'))
            {
              let process_root_tempate = false;
              if (_this.hasAttribute('data-dsb-template') && _this.dsb.helpers.has('process', 'template.GetFromPath'))
              {
                let imported_template = _this.dsb.helpers.run('process', 'template.GetFromPath', [_this.getAttribute('data-dsb-template'), false]);
                if (imported_template instanceof HTMLTemplateElement)
                {
                  process_root_tempate = imported_template;
                }
              }

              if (!process_root_tempate && 'root_template' in _this.dsb._._settings && _this.dsb._._settings.root_template instanceof HTMLTemplateElement)
              {
                process_root_tempate = _this.dsb._._settings.root_template;
              }
              _this.dsb.templates = {};
              let _templates = _this.getElementsByTagName("template");
              let _innerHTML = '';


              for (let i = 0; i < _templates.length; i++)
              {
                let set_as_root_template = false;
                let key = i;
                if (_templates[i].hasAttribute('data-label'))
                {
                  key = _templates[i].getAttribute('data-label');
                  if (key == 'root_template')
                  {
                    process_root_tempate = _templates[i];
                    set_as_root_template = true;
                  }
                } else

                {
                  if (i == 0)
                  {
                    process_root_tempate = _templates[i];
                    set_as_root_template = true;
                  }
                }

                if (!set_as_root_template)
                {
                  _this.dsb.helpers.run('session', 'add', ['templates', { [key]: _templates[i] }]);
                }
                _templates[i].remove();
              }
              if (process_root_tempate && process_root_tempate instanceof HTMLTemplateElement)
              {
                _this.dsb.element_templated = _this.dsb.helpers.run('process', 'template', [process_root_tempate, { 'innerHTML': _this.innerHTML, 'target': _this, 'template_type': _this.getAttribute('data-dsb-template-type') }, function (key, value) {
                  if (key == 'innerHTML' && value instanceof HTMLElement)
                  {
                    for (let i = 0; i < _this.children.length; i++)
                    {
                      if (_this.children[i] instanceof HTMLElement && !(_this.children[i] instanceof HTMLTemplateElement))
                      {
                        value.append(_this.children[i]);
                      }
                    }
                    _this.dsb.element = value;
                  }
                }]);
              }
            }

            if (!_this.shadowRoot || _this.shadowRoot == null)
            {
              _this.attachShadow({ mode: "open" });
            }

            if (!(_this.dsb.element_templated && _this.dsb.element_templated.startsWith('complete')))
            {
              let create_element = true;

              if (_this.dsb.element_templated)
              {
                create_element = false;
              }
              if (!(_this.dsb.element instanceof HTMLElement))
              {
                create_element = true;
              }
              if (create_element)
              {
                _this.dsb.element = document.createElement('div');
              }
              //_this.innerHTML = '';

              if (_this.dsb.element_templated)
              {
                if (_this.hasAttribute('class'))
                {
                  let a_wrapper = document.createElement('div');
                  a_wrapper.setAttribute('class', _this.getAttribute('class'));
                  a_wrapper.append(_this.dsb.element_templated);
                  _this.shadowRoot.append(a_wrapper);
                } else

                {
                  _this.shadowRoot.append(_this.dsb.element_templated);
                }
              } else

              {
                _this.dsb.element.innerHTML = _this.dsb.element_original;
                if (_this.hasAttribute('class'))
                {
                  _this.dsb.element.setAttribute('class', _this.getAttribute('class'));
                }
                _this.shadowRoot.append(_this.dsb.element);
              }
            } else

            {
              if (_this.dsb.element_templated === 'complete-set-placeholder')
              {
                let placeholder = _this.shadowRoot.querySelector('[data-dsb-placeholder]');
                if (placeholder instanceof HTMLElement)
                {
                  placeholder.removeAttribute('data-dsb-placeholder');
                  _this.dsb.element = placeholder;
                } else

                {
                  throw 'data-dsb-placeholder missing, cannot find body target!';
                }
              } else

              {
                _this.dsb.element = _this;
              }
            }

            if ('css' in _this.dsb._._settings)
            {
              // Setup styling

              let style = document.createElement("style");
              style.textContent = _CSS + _this.dsb._._settings.css;
              _this.shadowRoot.appendChild(style);
              _this.dsb.log('debug', 'constructor', 'Setup shadowDOM. To access innerHTML use dsb.getInnerHTML');
            }
            if ('onReady' in _this.dsb._._settings && typeof _this.dsb._._settings.onReady === 'function')
            {
              _this.dsb._._settings.onReady(_this.shadowRoot ? _this.shadowRoot : _this, _this);
            }

            _this.dsb.hooks.run('init:complete');
            _this.dsb.log('debug', 'connectedCallback.function___initHTML', 'Finished init of HTMLDsbElement');
            _this.dsb.state.set('pending');
            _this.connectedCallback();
          };

          this.dsb.state.set('init-innerHTML');

          let useObserver = this.innerHTML === '' ? true : false;
          useObserver = this.hasAttribute('data-dsb-waitToLoad') ? this.getAttribute('data-dsb-waitToLoad') : useObserver;
          if (useObserver)
          {
            const observer = new MutationObserver(mutations => {
              mutations.every(mutation => {
                observer.disconnect();
                if (mutation.type === "childList")
                {
                  _this.dsb.log('debug', 'connectedCallback.observer', 'childList updated, Processing innerHTML...');
                  function___initHTML();
                } else if (mutation.type === "attributes") {
                  _this.dsb.log('debug', 'connectedCallback.observer', 'attributes ' + mutation.attributeName + " was modified.");
                }
                return false;
              });
            });

            observer.observe(this, {
              childList: true });

          } else

          {
            queueMicrotask(() => function___initHTML());
            //setTimeout(() => function___initHTML());
          }

        }
        catch (ex)
        {
          this.dsb.log('error', 'constructor', 'Error instantiating hooks, parts and or helpers...', ex);
          throw ex;
        }
      }

      switch (this.dsb.state.get()) {

        case "pending":
          this.dsb.state.set('rendering');
          return this._pre_render();
        default:
          this.dsb.log('debug', 'connectedCallback', 'State "' + this.dsb.state.get() + '", so doing nothing....');
          break;}

    }
    catch (ex)
    {
      this.dsb.hooks.run('onFatalError', [500, this.dsb.element, ex]);
    }
  }

  async _pre_refresh()
  {
    try
    {
      this.dsb.state.set('refreshing');
      if ('_refresh' in this && typeof this._refresh === 'function')
      {
        await this._refresh();
      }
      this.dsb.state.set('ready');
    }
    catch (ex)
    {
      this.dsb.hooks.run('onFatalError', [500, this.dsb.element, ex]);
      this.dsb.log('error', '_pre_refresh', 'FatalError', ex);
    }
  }

  async _pre_render()
  {
    try
    {
      let _this = this;
      this.dsb.hooks.run('pre_render:init');
      this.dsb.state.set('loading');
      //await this._getProcessedSettings();
      //await this._getProcessedData();
      if (this.dsb.helpers.has('process', 'atts.settings'))
      {
        this._settings = await this.dsb.helpers.run('process', 'atts.settings', [!(typeof this._settings === 'object') ? this.getAttribute('settings') : this._settings], null, 'throw');
      }
      if (this.dsb.helpers.has('process', 'atts.data'))
      {
        this._data = await this.dsb.helpers.run('process', 'atts.data', [!(typeof this._data === 'object') ? this.getAttribute('data') : this._data, this.dsb.element], null, 'throw');
      }
      if (this.dsb.helpers.has('process', 'template.DataAttr'))
      {
        if (await this.dsb.helpers.run('process', 'template.DataAttr', [this.dsb.element, this._data], null, 'throw'))
        {
          this.dsb.state.set('templated');
        }
      }
      this.dsb.hooks.run('onPre_render:complete');
      this.dsb.log('debug', '_pre_render', 'Preparing to render (__render)[' + this._state + ']', this._data);
      await this._render();
      this.dsb.state.set('complete');
      return true;
    }
    catch (ex)
    {
      this.dsb.log('error', '_pre_render', 'FatalError', ex);
      this.dsb.hooks.run('onFatalError', [500, this.dsb.element, ex]);
    }
  }

  async _render()
  {
    this.dsb.log('warning', '_render', 'Your suppose to override _render in your class.... async _render(){...}');
  }}



function fetchHelper(_HELPERS, _CONTEXT = {}) {

  let _LOG = function (type, source, message, data = '')
  {
    source = 'helper-fetch.' + source;
    if ('has' in _HELPERS && _HELPERS.has('tools', 'logging'))
    {
      _HELPERS.run('tools', 'logging', [type, source, message, data]);
    } else

    {
      let _message = source + '- ' + message;
      switch (type) {

        case "debug":
          console.debug(_message, data);
          break;
        case "warning":
          console.warn(_message, data);
        case "info":
          console.info(_message, data);
          break;
        case "error":
          console.error(_message, data);
          break;
        default:
          console.log(_message, data);}

    }
  };
  if ('add' in _HELPERS && 'has' in _HELPERS)
  {
    let FETCH_CONNECTIONS = {};
    let FETCH = {};

    /**FETCH.addConnectionAsync =  async function(alias,url,options=false,auth=false)
                    {
                      if(!(alias in FETCH_CONNECTIONS))
                      {
                        if(!(typeof options === 'object'))
                        {
                          try
                          {
                            options = JSON.parse(JSON.stringify(options));
                          }
                          catch(ex)
                          {
                            _LOG('warning','addConnection','Alias: '+alias+' options doesnt seem to be JSON');
                          }
                           if(!(typeof options === 'object') || object === null)
                          {
                            options={};
                          }
                        }
                        if(!(typeof auth === 'object'))
                        {
                          try
                          {
                            auth = JSON.parse(JSON.stringify(auth));
                          }
                          catch(ex)
                          {
                            _LOG('warning','addConnection','Alias: '+alias+' auth doesnt seem to be JSON');
                          }
                          if(!(typeof auth === 'object') || auth === null)
                          {
                            auth={};
                          }
                        }
                         if(!('header' in options))
                        {
                          options.header = {};
                        }
                         let user_object = false;
                        if(('method' in auth) && ('target' in auth))
                        {
                          let user_token = false;
                          switch(auth.method)
                          {
                            case "variable":
                              try
                              {
                                if(typeof _target === 'string')
                                {
                                  let _global = (typeof window !== 'undefined'?window:(typeof global !== 'undefined'?global:null));
                                  if(_global != null)
                                  {
                                    user_object = this._getDataValue(_global,_target,null);
                                  }
                                  else
                                  {
                                    throw 'auth.method[variable].target cannot find a global (no window or global var)!';
                                  }
                                }
                                else if(typeof _target === 'object')
                                {
                                  user_object=_target;
                                }
                                 if(typeof user_object === 'object' && user_object!=null)
                                {
                                  if(!('isConnectionTokenValid' in user_object) || typeof user_object.isConnectionTokenValid !== 'function')
                                  {
                                    throw "Missing isConnectionTokenValid in user_object";
                                  }
                                  if(!('getConnectionToken' in user_object) || typeof user_object.getConnectionToken !== 'function')
                                  {
                                    throw "Missing getConnectionToken in user_object";
                                  }
                                }
                              }
                              catch(ex)
                              {
                                throw {code:'400', message: "Error processing auth.method[variable]: "+ex,_target};
                              }
                              break;
                            case "cookie":
                              user_object={};
                              user_object.isConnectionTokenValid=function(){return true};
                              user_object.getConnectionToken=function(){return _HELPERS.run('cookies','get',[auth.target])};
                              break;
                            case "target":
                              user_object={};
                              user_object.isConnectionTokenValid=function(){return true};
                              user_object.getConnectionToken=function(){return auth.target};
                              break;
                            default:
                              user_token=false;
                              __LOG('debug','connections['+alias+'].fetch','Unknown auth.method',auth.hook);
                              break;
                          }
                        }
                         url=(url.endsWith('/')?url:url+'/');
                         FETCH_CONNECTIONS[alias]={};
                        FETCH_CONNECTIONS[alias].dataset={};
                        FETCH_CONNECTIONS[alias].fetch = async function(query,headers)
                        {
                          let result={code:'500', message: 'Unknown error'};
                          try
                          {
                            for(let aheaders in headers)
                            {
                              options.header[aheaders]=headers[aheaders];
                            }
                             if(user_object && typeof user_object === 'object')
                            {
                              let is_logged_in = false;
                              if(('isConnectionTokenValid' in user_object))
                              {
                                if(await user_object.isConnectionTokenValid(alias,require_role))
                                {
                                  is_logged_in=true;
                                  if(('getConnectionToken' in user_object) && (typeof user_object.getConnectionToken === 'function'))
                                  {
                                    user_token = user_object.getConnectionToken(alias);
                                  }
                                }
                              }
                              if(!is_logged_in)
                              {
                                throw {code:'401', message: 'You need to be a '+(typeof require_role === 'string'?require_role:'user')+' to access this resource'};
                              }
                            }
                             if('login_only' in auth && auth.login_only == 'yes')
                            {
                              if(user_token && typeof user_token === 'string' && user_token.length>0)
                              {
                                if('Authorization' in _options)
                                {
                                  options['Authorization'].replace('{user_token}',user_token);
                                }
                                else
                                {
                                  url.replace('{user_token}',user_token);
                                }
                              }
                              else
                              {
                                throw {code:'401', message: 'You need to be a '+(typeof require_role === 'string'?require_role:'user')+' to access this resource (token missing)'};
                              }
                            }
                             __LOG('debug','connections['+alias+'].fetch','Fetching',url+query,options);
                            result = await fetch(url+query,options);
                            if(('login_only' in auth && auth.login_only == 'yes') && ('try_login_on_401' in auth && auth.try_login_on_401 == 'yes') && result.code==401)
                            {
                              __LOG('debug','get','1st try 401-ed, trying again...');
                              if(user_object && typeof user_object === 'object')
                              {
                                if(('renewSession' in user_object))
                                {
                                  await user_object.renewSession();
                                }
                              }
                              return _FETCH_CONNECTIONS[alias].fetch(query,headers);
                            }
                          }
                          catch(ex)
                          {
                            if(typeof ex === 'object' && 'code' in ex)
                            {
                              result=ex;
                            }
                            else
                            {
                              result={'code':500,'message':ex};
                            }
                          }
                          return result;
                        }
                         _LOG('debug','addConnection','Alias: '+alias+' connection added.');
                        return true;
                      }
                      else
                      {
                        _LOG('debug','addConnection','Alias: '+alias+' connection already exists. Skipping');
                      }
                      return false;
                    };
                    */











    FETCH.addConnectionAsync = async function (alias, url, options = false, auth = false)
    {
      if (!(alias in FETCH_CONNECTIONS))
      {
        if (!(typeof options === 'object'))
        {
          try
          {
            options = JSON.parse(JSON.stringify(options));
          }
          catch (ex)
          {
            _LOG('warning', 'addConnection', 'Alias: ' + alias + ' options doesnt seem to be JSON');
          }

          if (!(typeof options === 'object') || object === null)
          {
            options = {};
          }
        }
        if (!(typeof auth === 'object'))
        {
          try
          {
            auth = JSON.parse(JSON.stringify(auth));
          }
          catch (ex)
          {
            _LOG('warning', 'addConnection', 'Alias: ' + alias + ' auth doesnt seem to be JSON');
          }
          if (!(typeof auth === 'object') || auth === null)
          {
            auth = {};
          }
        }

        if (!('header' in options))
        {
          options.header = {};
        }

        url = url.endsWith('/') ? url : url + '/';

        FETCH_CONNECTIONS[alias] = {};
        FETCH_CONNECTIONS[alias].url = url;
        FETCH_CONNECTIONS[alias].options = options;
        FETCH_CONNECTIONS[alias].auth = auth;
        FETCH_CONNECTIONS[alias].dataset = {};

        _LOG('debug', 'addConnection', 'Alias: ' + alias + ' connection added.');
        return true;
      } else

      {
        _LOG('debug', 'addConnection', 'Alias: ' + alias + ' connection already exists. Skipping');
      }
      return false;
    };

    FETCH.getAsync = async function (url, options = {}, allow_offline = false, retry = true, auth = false)
    {
      if (!(typeof options === 'object'))
      {
        options = {};
      }
      options.method = 'GET';
      return FETCH._fetchBatch(url, options, allow_offline, retry, auth);
    };

    FETCH.postAsync = async function (url, data, options = {}, allow_offline = false, retry = true, auth = false)
    {
      if (!data)
      {
        throw { 'code': 400, 'message': 'missing data in postAsync' };
      }
      if (!(typeof options === 'object'))
      {
        options = {};
      }
      options.method = 'POST';
      options.body = data;
      return FETCH._fetchBatch(url, options, allow_offline, retry, auth);
    };

    FETCH._fetchBatch = async function (urlString, options = {}, allow_offline = false, retry = true, auth = false)
    {

      let settings = {};
      let urls = [];
      let results = [];

      if ('_' in options && typeof options._ === 'object')
      {
        settings = JSON.parse(JSON.stringify(options['_']));
        delete options['_'];
      }

      if (!('operator' in settings))
      {
        settings.operator = {};
      }

      if (!('type' in settings.operator))
      {
        settings.operator.type = 'or';
      }

      if (!('settings' in settings.operator))
      {
        settings.operator.settings = {};
      }

      if (!('callback' in settings))
      {
        settings.callback = false;
      }

      if (!Array.isArray(urlString))
      {
        let url_object = _HELPERS.run('process', 'query', [urlString, {}, 'object'], false);
        if ('or' in url_object)
        {
          settings.operator.type = 'or';
          urls = url_object.or;
        } else
        if ('and' in url_object)
        {
          settings.operator.type = 'and';
          urls = url_object.and;
        } else

        {
          urls.push(urlString);
        }
        //urls=urlString.split(/\|https?:\/\//);
      } else

      {
        urls = urlString;
      }

      let function__postProcess = function (_data)
      {
        let function__process = function (__data)
        {
          if ('process' in settings)
          {
            if (!(typeof settings.process === 'object'))
            {
              settings.process = _HELPERS.run('process', 'hash', [settings.process], false);
            }
            __data = _HELPERS.run('process', 'data', [__data, settings.process], false);
          }
          if (settings.callback && typeof settings.callback === 'function')
          {
            __data = settings.callback(__data);
          }
          return __data;
        };
        if ('select' in settings)
        {
          for (let i = 0; i < _data.length; i++)
          {
            _data[i] = function__process(_HELPERS.run('tools', 'getValuesFromJSON', [settings.select, _data[i]], false));
          }
        } else

        {
          _data = function__process(_data);
        }
        return _data;
      };

      let operator_accept_code = 'accept_codes' in settings.operator.settings && Array.isArray(settings.operator.settings.accept_codes) ? settings.operator.settings.accept_codes : false;
      let operator_reject_code = 'reject_codes' in settings.operator.settings && Array.isArray(settings.operator.settings.reject_codes) ? settings.operator.settings.reject_codes : false;

      switch (settings.operator.type) {

        case "and":
          if (!operator_accept_code && urls.length > 1)
          {
            operator_accept_code = ['200', '201', 200, 201];
          }
          let promises = [];
          for (let a_url of urls)
          {
            let a_url_settings = {};
            if (Array.isArray(a_url))
            {
              if (a_url.length == 2)
              {
                a_url_settings = a_url[1];
                a_url = a_url[0];
              } else

              {
                throw 'Incorectally formatted url/options array!';
              }
            }
            promises.push(new Promise(async function (resolve, reject) {
              try
              {
                let result = await FETCH._fetch(a_url, 'options' in a_url_settings ? a_url_settings.options : options, allow_offline, 'retry' in a_url_settings ? a_url_settings.retry : retry, 'auth' in a_url_settings ? a_url_settings.auth : auth);

                if (operator_reject_code && operator_reject_code.includes(result.code))
                {
                  throw result;
                } else

                {
                  let accepted = true;
                  if (Array.isArray(operator_accept_code))
                  {
                    accepted = operator_accept_code.includes(result.code);
                  }
                  if (accepted)
                  {
                    result.data = function__postProcess(result.data);
                    resolve(result);
                  } else

                  {
                    resolve(null);
                  }
                }
              }
              catch (ex)
              {
                reject(ex);
              }
            }));
          }
          await Promise.all(promises).then(values => {
            results = values.filter(element => element !== null);
          }).catch(error => {
            throw error;
          });
          break;
        case "or":
          if (!operator_accept_code && urls.length > 1)
          {
            operator_accept_code = ['200', '201', 200, 201];
          }
        case "all":
          let result = { 'code': 500 };
          for (let a_url of urls)
          {
            result = { 'code': 500 };
            try
            {
              let a_url_settings = {};
              if (Array.isArray(a_url))
              {
                if (a_url.length == 2)
                {
                  a_url_settings = a_url[1];
                  a_url = a_url[0];
                } else

                {
                  throw 'Incorectally formatted url/options array!';
                }
              }
              result = await FETCH._fetch(a_url, 'options' in a_url_settings ? a_url_settings.options : options, allow_offline, 'retry' in a_url_settings ? a_url_settings.retry : retry, 'auth' in a_url_settings ? a_url_settings.auth : auth);
              let accepted = true;
              if (Array.isArray(operator_accept_code))
              {
                accepted = operator_accept_code.includes(result.code);
              }
              if (accepted)
              {
                result.data = function__postProcess(result.data);
                results.push(result);
                if (settings.operator.type === 'or')
                {
                  break;
                }
              }
            }
            catch (ex)
            {
              result.message = ex;
            }
          }}


      if ('merge' in settings && settings.merge == true)
      {
        if (results.length > 1)
        {
          let merged_results = false;
          for (let a_result of results)
          {
            if (merged_results === false)
            {
              merged_results = {};
              merged_results.code = 200;
              merged_results.status = 'merged';
              merged_results.source = [];
              merged_results.source.push({ 'status': a_result.state, 'url': a_result.source });
              merged_results.data = a_result.data;
            } else

            {
              let source = { 'status': a_result.state, 'url': a_result.source };
              try
              {
                merged_results.data = _HELPERS.run('tools', 'mergeObjects', [merged_results.data, a_result.data], false);
              }
              catch (ex)
              {
                source.error = ex;
              }
              merged_results.source.push(source);
            }
          }
          results = merged_results;
        }
      }

      if (urls.length == 1)
      {
        return results[0];
      } else

      {
        return results;
      }
    };

    FETCH._fetch = async function (urlString, optionsObject = {}, allow_offline = false, retry = true, authObject = false)
    {
      let result = {};
      result.code = 500;
      result.state = 'fetch-failed';
      result.data = null;
      let url = urlString;
      let options = JSON.parse(JSON.stringify(optionsObject));
      let auth = JSON.parse(JSON.stringify(authObject));
      let hash = false;
      let fetch_response = {};

      if (retry)
      {
        let retry_type = 'default';
        if (typeof retry === 'string' && retry.length > 0)
        {
          retry_type = retry;
        }
        if (!(typeof retry === 'object'))
        {
          retry = {};
        }
        if (!('type' in retry))
        {
          retry.type = retry_type;
        }
        if (!('count' in retry))
        {
          retry.count = 3;
        }
        if (!('delay' in retry))
        {
          retry.delay = 3;
        }
      }
      try
      {
        let is_offline = await _HELPERS.run('networking', 'isOfflineAsync', [], false);
        if (is_offline)
        {
          if (!allow_offline)
          {
            throw { code: '503', message: 'Offline without allow_offline', allow_offline };
          }
        }
        if (_HELPERS.has('process', 'moustache'))
        {
          urlString = _HELPERS.run('process', 'moustache', [urlString]);
        } else

        {
          _LOG('warning', 'fetch', 'Helper helper(process,moustache) missing! No moustache based opperations will be preformed.');
        }
        url = new URL(urlString);
        let underscore_options = {};
        underscore_options.check_envalope = true;
        if ('hash' in url)
        {
          if (_HELPERS.has('process', 'hash'))
          {
            hash = _HELPERS.run('process', 'hash', [url.hash, {}, 'object']);
            if ('__' in hash)
            {
              for (let an_ in hash.__)
              {
                underscore_options[an_] = hash.__[an_];
              }
              delete hash.__;
            }
          } else

          {
            _LOG('warning', 'fetch', 'Helper helper(process,hash) required! No hash based opperations will be preformed.');
          }
        }

        if (!(typeof options === 'object'))
        {
          options = {};
        }

        async function function__populateAuth(auth, url, options)
        {
          if (auth && typeof auth === 'object')
          {
            if ('type' in auth && 'target' in auth)
            {
              if (!('method' in auth))
              {
                auth.method = 'bearer';
              }
              auth.user_object = {};
              let user_token = false;
              switch (auth.type) {

                case "variable":
                  try
                  {
                    if (typeof auth.target === 'string')
                    {
                      let _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : null;
                      if (_global != null && _HELPERS.has('tools', 'getValuesFromJSON'))
                      {
                        auth.user_object = _HELPERS.run('tools', 'getValuesFromJSON', [_global, auth.target, null]);
                      } else

                      {
                        throw 'auth.type[variable].target cannot find a global (no window or global var)!';
                      }
                    } else
                    if (typeof auth.target === 'object')
                    {
                      auth.user_object = auth.target;
                    }

                    if (typeof auth.user_object === 'object' && auth.user_object != null)
                    {
                      if (!('isConnectionTokenValid' in auth.user_object) || typeof auth.user_object.isConnectionTokenValid !== 'function')
                      {
                        throw "Missing isConnectionTokenValid in auth.user_object";
                      }
                      if (!('getConnectionToken' in auth.user_object) || typeof auth.user_object.getConnectionToken !== 'function')
                      {
                        throw "Missing getConnectionToken in auth.user_object";
                      }
                    }
                  }
                  catch (ex)
                  {
                    throw { code: '400', message: "Error processing auth.type[variable]: " + ex, target: auth.target };
                  }
                  break;
                case "cookie":
                  auth.user_object.isConnectionTokenValid = function () {return true;};
                  auth.user_object.getConnectionToken = function () {return _HELPERS.run('cookies', 'get', [auth.target]);};
                  break;
                case "target":
                  auth.user_object.isConnectionTokenValid = function () {return true;};
                  auth.user_object.getConnectionToken = function () {return auth.target;};
                  break;
                default:
                  user_token = false;
                  __LOG('debug', '_fetch', 'Unknown auth.type', auth.type);
                  break;}

              if (auth.user_object && typeof auth.user_object === 'object' && auth.user_object !== null)
              {
                let is_logged_in = false;
                if ('isConnectionTokenValid' in auth.user_object && typeof auth.user_object.isConnectionTokenValid === 'function')
                {
                  if (await auth.user_object.isConnectionTokenValid())
                  {
                    is_logged_in = true;
                    if ('getConnectionToken' in auth.user_object && typeof auth.user_object.getConnectionToken === 'function')
                    {
                      user_token = await auth.user_object.getConnectionToken();
                    }
                  }
                }
                if (!is_logged_in)
                {
                  throw { code: '401', message: 'You need to be Authenticated to access this resource' };
                }
              }

              if (user_token && typeof user_token === 'string' && user_token.length > 0)
              {
                if (!('headers' in options))
                {
                  options.headers = {};
                }
                switch (auth.method.toLowerCase()) {

                  case "bearer":
                    options.headers['Authorization'] = 'Bearer {auth_token}';
                  case "authorization":
                    if ('Authorization' in options.headers)
                    {
                      options.headers['Authorization'] = options.headers['Authorization'].replace('{auth_token}', user_token);
                    }
                    break;
                  case "url":
                    url = url.replace('{auth_token}', user_token);
                    break;
                  default:
                    throw 'Unknown auth.method "' + auth.method.toLowerCase() + '"';
                    break;}

              } else

              {
                throw { code: '401', message: 'You need to be a ' + (typeof require_role === 'string' ? require_role : 'user') + ' to access this resource (token missing)' };
              }
            }
          }
          return [auth, url, options];
        }

        if (!('method' in options))
        {
          options.method = 'GET';
        }

        if (options.method === 'POST')
        {
          if (!('headers' in options))
          {
            options.headers = {};
          }
          if ('body' in options)
          {
            if (typeof options.body === 'object')
            {
              if (!('content-type' in options.headers))
              {
                options.headers['content-type'] = 'application/json';
              }
              options.body = JSON.stringify(options.body);
            } else
            if (!(typeof options.body === 'string'))
            {
              throw 'body is not an object or a string... body required for POST';
            }
          } else

          {
            throw 'body required for POST';
          }
          if (!('content-type' in options.headers))
          {
            options.headers['content-type'] = 'application/x-www-form-urlencoded';
          }
          _LOG('debug', '_fetch', 'Posting: ' + url, options.body);
        } else

        {
          _LOG('debug', '_fetch', 'Fetching [' + options.method + ']: ' + url);
        }

        let function__try = async function ()
        {
          let retry_action = function () {function__try();};
          let fetch_url = false;
          if (url.protocol.startsWith('http:') || url.protocol.startsWith('https:'))
          {
            fetch_url = url.href;
            [auth, fetch_url, options] = await function__populateAuth(auth, fetch_url, options);
          } else

          {
            let connection_alias = url.protocol.replace(':', '');
            if (connection_alias in FETCH_CONNECTIONS)
            {
              fetch_url = FETCH_CONNECTIONS[connection_alias].url;
              options = FETCH_CONNECTIONS[connection_alias].options;
              auth = FETCH_CONNECTIONS[connection_alias].auth;
              [auth, fetch_url, options] = await function__populateAuth(auth, fetch_url, options);
            } else

            {
              throw 'Unknown connection "' + connection_alias + '"';
            }
          }
          if (fetch_url)
          {
            fetch_response = await fetch(fetch_url, options);
          } else

          {
            throw 'Missing fetch_url!';
          }

          if (typeof fetch_response === 'object' && 'text' in fetch_response)
          {
            if ('status' in fetch_response)
            {
              result.code = fetch_response.status;
              if (result.code == 200)
              {
                result.state = 'success';
              }
            }
            if ('statusText' in fetch_response && fetch_response.statusText.length > 0)
            {
              result.state = fetch_response.statusText;
              result.message = fetch_response.statusText;
            }
            result.data = await fetch_response.text();
            try
            {
              result.data = JSON.parse(result.data);
              if (underscore_options.check_envalope)
              {
                if ('code' in result.data && 'state' in result.data && 'data' in result.data)
                {
                  result = result.data;
                } else

                {
                  _LOG('debug', 'fetch', 'No envalope detected.', { 'data': result.data });
                }
              }
            }
            catch (ex)
            {
              //Ok probably just text
            }

            if (result.code == 202 || [201, 201, 200].includes(result.code) && retry.type === 'pending_que') // Pending
              {
                result.state = 'pending';
                if ('data' in result && typeof result.data === 'object')
                {
                  if ('platform' in result && typeof result.platform === 'string' && result.platform == 'datastorebuilder-api')
                  {
                    let que = {};
                    if (Array.isArray(result.data))
                    {
                      if (result.data.length > 0)
                      {
                        que = result.data[0];
                      } else

                      {
                        throw 'Data array seems to be empty';
                      }
                    } else

                    {
                      que = result.data;
                    }
                    if (typeof que === 'object')
                    {
                      if ('code' in que)
                      {
                        if ('que_endpoint' in que)
                        {
                          if ([202, "202"].includes(que.code))
                          {
                            let que_endpoint = url.origin + '/' + que.que_endpoint;
                            result.state = 'pending_que';
                            if (url.searchParams.has('auth_jwt'))
                            {
                              que_endpoint = que_endpoint + '?auth_jwt=' + url.searchParams.get('auth_jwt');
                            }
                            retry.type = 'pending_que';
                            _LOG('debug', '_fetch', 'Fetch responce ' + que.code + '..trying que.', que_endpoint);
                            if (retry.count > 0)
                            {
                              if (result.code !== 202)
                              {
                                if (_HELPERS.has('tools', 'delaySecAsync'))
                                {
                                  _LOG('debug', '_fetch', 'Fetch responce ' + que.code + '..delaying for ' + retry.delay + ' sec...');
                                  await _HELPERS.run('tools', 'delaySecAsync', [retry.delay]);
                                } else

                                {
                                  _LOG('warning', '_fetch', 'Fetch responce ' + que.code + '..CANNOT scheduling polling of que!', que_endpoint);
                                }
                                retry.count--;
                              }
                              return await FETCH.getAsync(que_endpoint, {}, false, retry);
                            } else

                            {
                              throw { 'code': 408, 'message': 'Timeout fetching "' + que_endpoint + '"' };
                            }
                          } else

                          {
                            _LOG('warning', '_fetch', 'Code returned nolonger 202... may be ok', { 'data': result.data, 'que': que });
                            for (let a_key in result)
                            {
                              if (a_key in que)
                              {
                                result[a_key] = que[a_key];
                              }
                            }
                          }
                        } else

                        {
                          _LOG('debug', '_fetch', 'No que_endpoint found in "' + que_endpoint + '"... probably ok then', { 'data': result.data, 'que': que });
                        }
                      }
                    } else

                    {
                      _LOG('warning', '_fetch', 'No que is not an object!', { 'data': result.data, 'que': que });
                    }
                  }
                }
              }

            if (result.code == 401)
            {
              if (retry.type === 'auth')
              {
                _LOG('debug', '_fetch', '401 (Auth needed), tried renew failed!');
              } else

              {
                if (auth && typeof auth === 'object' && auth !== null &&
                'user_object' in auth && typeof auth.user_object === 'object' && auth.user_object !== null &&
                'renew' in auth.user_object && typeof auth.user_object.renew === 'function')
                {
                  _LOG('debug', '_fetch', '401 (Auth needed), trying to renews.....');
                  await auth.user_object.renew();
                  return await FETCH.getAsync(urlString, optionsObject, false, { 'type': "auth" }, authObject);
                } else

                {
                  _LOG('debug', '_fetch', '401 (Auth needed), no renew set. Giving up.');
                }
              }
            }


            if (['408', '503', 408, 503].includes(result.code))
            {
              if (retry.count > 0)
              {
                if (_HELPERS.has('tools', 'delaySecAsync'))
                {
                  _LOG('debug', 'fetch', 'Fetch responce ' + result.code + '..delaying for ' + retry.delay + ' sec...');
                  await _HELPERS.run('tools', 'delaySecAsync', [retry.delay]);
                } else

                {
                  _LOG('warning', 'fetch', 'Fetch responce ' + result.code + '..CANNOT scheduling polling of que!');
                }
                retry.count--;
                await function__try();
              } else

              {
                throw { 'code': 408, 'message': 'Timeout fetching "' + url + '"' };
              }
            }
            if (typeof hash === 'object' && Object.keys(hash).length > 0)
            {
              if (_HELPERS.has('process', 'data'))
              {
                let processDataMode = 'ommit';
                _LOG('debug', '_fetch', 'Filtering results for ' + urlString + '', { 'data': result.data, 'hash': hash, 'processDataMode': processDataMode });
                if (typeof result.data === 'object')
                {
                  result.data = _HELPERS.run('process', 'data', [result.data, hash, processDataMode]);
                }
              } else

              {
                _LOG('warning', '_fetch', 'Helper helper(process,data) required! Returning data unaffected.');
              }
            }

            /**if(!Array.isArray(result.data))
              {
                let _fetch_data=[];
                _fetch_data.push(result.data);
                result.data=_fetch_data;
              }
              */

          }
          false;
        };
        let has_return = await function__try();
        if (has_return)
        {
          return has_return;
        }
      }
      catch (ex)
      {
        result.code = 500;
        result.state = 'error';
        if (typeof ex === 'object')
        {
          if ('code' in ex)
          {
            result.code = ex.code;
          }
          if ('message' in ex)
          {
            result.message = ex.message;
          }
          if ('data' in ex)
          {
            result.data = ex.data;
          }
        } else

        {
          result.message = ex;
        }
      }
      if (['200', '201', 200, 201].includes(result.code))
      {
        _LOG('debug', '_fetch', 'Found ' + url, { 'hash': hash, 'result': result, 'fetch_response': fetch_response });
      } else
      if (['202', 202, '404', 404].includes(result.code))
      {
        _LOG('warning', '_fetch', 'Found ' + url, { 'hash': hash, 'result': result, 'fetch_response': fetch_response });
      } else

      {
        _LOG('error', '_fetch', 'Error ' + url, { 'hash': hash, 'result': result, 'fetch_response': fetch_response });
      }
      if (!('source' in result))
      {
        result.source = urlString;
      }
      return result;
    };

    _HELPERS.add('fetch', 'get', FETCH.getAsync);
    _HELPERS.add('fetch', 'post', FETCH.postAsync);
    _HELPERS.add('fetch', 'getAsync', FETCH.getAsync);
    _HELPERS.add('fetch', 'postAsync', FETCH.postAsync);
    _HELPERS.add('fetch', 'addConnection', FETCH.addConnectionAsync);
  } else

  {
    _LOG('error', 'init', 'No _HELPERS.add or _HELPERS.has found!', _HELPERS);
  }

}

function cookiesHelper(_HELPERS, _CONTEXT = {}) {

  let _LOG = function (type, source, message, data = '')
  {
    source = 'helper-cookies.' + source;
    if ('has' in _HELPERS && _HELPERS.has('tools', 'logging'))
    {
      _HELPERS.run('tools', 'logging', [type, source, message, data]);
    } else

    {
      let _message = source + '- ' + message;
      switch (type) {

        case "debug":
          console.debug(_message, data);
          break;
        case "warning":
          console.warn(_message, data);
        case "info":
          console.info(_message, data);
          break;
        case "error":
          console.error(_message, data);
          break;
        default:
          console.log(_message, data);}

    }
  };
  if ('add' in _HELPERS && 'has' in _HELPERS)
  {

    let COOKIES = {};

    COOKIES.get = function (cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          let myCookie = c.substring(name.length, c.length);
          try
          {
            JSON.parse(myCookie);
            return myCookie;
          }
          catch (e)
          {
            return myCookie;
          }
        }
      }
      return "";
    };

    COOKIES.set = function (cname, cvalue, exdays = 1, path = '/', domain = false) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      if (domain)
      {
        document.cookie = cname + "=" + cvalue + ";" + expires + "; path=" + path + "; SameSite= None; domain=" + domain;
      } else

      {
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=" + path;
      }
      this._log('debug', '_setCookie', 'Created cookie ' + cname + '...');
    };


    COOKIES.delete = function (name, path, domain) {
      if (COOKIES.get(name)) {
        this._log('debug', 'Deleting cookie "' + name + '", path:"' + path + '", domain:"' + domain + '"');
        document.cookie = name + "=" + (
        path ? ";path=" + path : "") + (
        domain ? ";domain=" + domain : "") +
        ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
      }
    };

    _HELPERS.add('cookies', 'set', COOKIES.set);
    _HELPERS.add('cookies', 'delete', COOKIES.delete);
    _HELPERS.add('cookies', 'get', COOKIES.get);
  } else

  {
    _LOG('error', 'init', 'No _HELPERS.add or _HELPERS.has found!', _HELPERS);
  }

}

function processHelper(_HELPERS, _FILTERS = {}) {

  let _LOG = function (type, source, message, data = '')
  {
    source = 'helper-process.' + source;
    if ('has' in _HELPERS && _HELPERS.has('tools', 'logging'))
    {
      _HELPERS.run('tools', 'logging', [type, source, message, data]);
    } else

    {
      let _message = source + '- ' + message;
      switch (type) {

        case "debug":
          console.debug(_message, data);
          break;
        case "warning":
          console.warn(_message, data);
        case "info":
          console.info(_message, data);
          break;
        case "error":
          console.error(_message, data);
          break;
        default:
          console.log(_message, data);}

    }
  };
  if ('add' in _HELPERS && 'has' in _HELPERS)
  {
    let PROCESS = {};
    PROCESS.query = function (query, params = {}, mode = true)
    {
      const getQueryParams = function (query, _params = {}, mode = false)
      {
        let params = {};
        if (typeof query === 'string')
        {
          if (query.includes('?'))
          {
            query = query.substring(query.indexOf('?') + 1);
          }
          query = PROCESS.moustache(query);
          new URLSearchParams(query).forEach((value, key) => {
            let decodedKey = decodeURIComponent(key);
            let decodedValue = decodeURIComponent(value);

            switch (decodedValue) {

              case "{{today}}":
                decodedValue = PROCESS.format_date('now', 'Y-m-d');
                break;
              case "{{yesterday}}":
                decodedValue = PROCESS.format_date('yesterday', 'Y-m-d');
                break;
              case "{{yesterday_timestamp}}":
                decodedValue = PROCESS.format_date('yesterday', 'timestamp_y-m-d');
                break;
              case "{{today_timestamp}}":
                decodedValue = PROCESS.format_date('now', 'timestamp_y-m-d');
                break;
              case "{{tomorrow}}":
                decodedValue = PROCESS.format_date('tomorrow', 'Y-m-d');
                break;
              default:
                if (decodedValue.startsWith('{{format_date|'))
                {
                  let format_date_params = decodedValue.split('{{format_date|');
                  if (format_date_params.length == 2)
                  {
                    format_date_params[1].replaceAll('{', '');
                    format_date_params[1].split(',');
                    if (format_date_params[1].length == 2)
                    {
                      decodedValue = PROCESS.format_date(format_date_params[1][0], format_date_params[1][1]);
                    }
                  }
                }
                break;}


            // This key is part of an array
            if (decodedKey.endsWith("[]"))
            {
              decodedKey = decodedKey.replace("[]", "");
              params[decodedKey] || (params[decodedKey] = []);
              params[decodedKey].push(decodedValue);
              // Just a regular parameter
            } else

            {
              let is_object = [...decodedKey.matchAll(/\[(.*?)\]/g)].map(match => match[1]);
              if (is_object.length > 0)
              {
                let newKey = decodedKey.split('[')[0];
                params[newKey] = {};
                params[newKey][is_object[0]] = decodedValue;
              } else

              {
                params[decodedKey] = decodedValue;
              }
            }
          });
          if (mode == 'diff')
          {
            let diff = {};
            for (let _param_key in _params)
            {
              if (_param_key in params)
              {
                if (params[_param_key] == _params[_param_key])
                {
                  if (!('same' in diff))
                  {
                    diff.same = {};
                  }
                  diff.same[_param_key] = params[_param_key];
                } else

                {
                  if (!('changed' in diff))
                  {
                    diff.changed = {};
                  }
                  diff.changed[_param_key] = {};
                  diff.changed[_param_key].from = params[_param_key];
                  diff.changed[_param_key].to = _params[_param_key];
                }
              } else

              {
                if (!('missing' in diff))
                {
                  diff.missing = {};
                }
                diff.missing[_param_key] = _params[_param_key];
              }
            }
            return diff;
          } else

          {
            // Update with _params
            for (let _param_key in _params)
            {
              params[_param_key] = _params[_param_key];
            }

            if (mode == 'cleanse')
            {
              // Remove missing
              for (let param_key in params)
              {
                if (!(param_key in _params))
                {
                  delete params[param_key];
                }
              }
            }
          }
        }
        return params;
      };
      if (mode == 'diff')
      {
        if (typeof params !== 'object')
        {
          params = getQueryParams(params);
        }
        return getQueryParams(query, params, mode);
      } else
      if (mode == 'object')
      {
        return getQueryParams(query, params, mode);
      } else

      {
        let thisQueryString = [];
        let url_params = getQueryParams(query, params, mode);
        for (let aUrl_paramsKey in url_params)
        {
          if (Array.isArray(url_params[aUrl_paramsKey]))
          {
            for (let i = 0; i < url_params[aUrl_paramsKey].length; i++)
            {
              thisQueryString.push(aUrl_paramsKey + '[]=' + url_params[aUrl_paramsKey][i]);
            }
          } else

          {
            thisQueryString.push(aUrl_paramsKey + '=' + url_params[aUrl_paramsKey]);
          }
        }return thisQueryString.join('&');
        //let url_params = new URLSearchParams(getQueryParams(query,params,mode));
        //return url_params.toString();
      }
    };

    PROCESS.hash = function (target, data = {}, mode = true)
    {
      let result = '';
      let function___processHash = function (this_url, data = {}, mode = true)
      {
        if (!this_url.startsWith('#'))
        {
          this_url = '#' + this_url;
        }
        let hash = decodeURIComponent(this_url);
        if (hash.length > 0 && hash.includes('#'))
        {
          let _hashes = hash.split('#').filter(function (i) {return i;});

          if (mode === 'object')
          {
            return PROCESS.query(_hashes.length > 1 ? _hashes[1] : _hashes[0], data, 'object');
          } else

          {
            return _hashes[0] + '#' + PROCESS.query(_hashes[1], data);
          }
        }
        return {};
      };

      if (Array.isArray(target))
      {
        result = [];
        for (let i = 0; i < target.length; i++)
        {
          result[i] = function___processHash(target, data, mode);
        }
      } else
      if (typeof string == 'object')
      {
        result = {};
        for (let atarget in target)
        {
          result[atarget] = function___processHash(target[atarget], data, mode);
        }
      } else

      {
        result = function___processHash(target, data, mode);
      }
      return result;
    };

    PROCESS.format_date = function (_timestamp, format = 'default', show_time = false)
    {
      let dates = [];
      let return_dates = [];

      const calculateTimimg = function (d) {
        let months = 0,years = 0,days = 0,weeks = 0,total = d;
        while (d) {
          if (d >= 365) {
            years++;
            d -= 365;
          } else if (d >= 30) {
            months++;
            d -= 30;
          } else if (d >= 7) {
            weeks++;
            d -= 7;
          } else {
            days++;
            d--;
          }
        }return {
          years, months, weeks, days, total };

      };

      const function__getYearWeekNo = function (adate)
      {
        const d = new Date(Date.UTC(adate.getFullYear(), adate.getMonth(), adate.getDate()));
        const day = d.getUTCDay() || 7;
        d.setUTCDate(d.getUTCDate() + 4 - day);
        const isoYear = d.getUTCFullYear();
        const yearStart = new Date(Date.UTC(isoYear, 0, 1));
        const weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
        return [isoYear, weekNo];
      };

      const function__getDateFromYearWeekDay = function (year_week_day)
      {
        const m = year_week_day.match(/^(\d{4})-W(\d{1,2})-(\d)$/i);
        if (m)
        {
          const year = Number(m[1]);
          const week = Number(m[2]);
          const weekdayMondayZero = Number(m[3]);
          if (weekdayMondayZero < 0 || weekdayMondayZero > 6)
          {
            throw new Error("weekday must be 0..6 (Monday=0)");
          }
          // ISO week: week 1 is the week with the year's first Thursday.
          // Jan 4th of the year == ISO week 1
          const jan4 = new Date(Date.UTC(year, 0, 4));
          const dayOfWeekJan4 = jan4.getUTCDay(); // 0=Sun .. 6=Sat
          // convert to ISO weekday where Monday=1..Sunday=7
          const isoWeekdayJan4 = dayOfWeekJan4 === 0 ? 7 : dayOfWeekJan4;
          const mondayOfWeek1 = new Date(jan4);
          mondayOfWeek1.setUTCDate(jan4.getUTCDate() - (isoWeekdayJan4 - 1));
          // compute target date: monday of week 1 + (week-1) weeks + weekday offset (Monday=0)
          const daysFromWeek1 = (week - 1) * 7 + weekdayMondayZero;
          let date = new Date(mondayOfWeek1);
          date.setUTCDate(mondayOfWeek1.getUTCDate() + daysFromWeek1);
          return date;
        }
        return false;
      };

      let timestamps = [];
      let singe_mode = false;
      if (!Array.isArray(_timestamp))
      {
        timestamps.push(_timestamp);
        singe_mode = true;
      } else

      {
        timestamps = _timestamp;
      }

      for (let timestamp of timestamps)
      {
        let timestamp_options = false;
        let date = null;
        if (typeof timestamp === 'object')
        {
          if ('options' in timestamp)
          {
            timestamp_options = timestamp.options;
          }
          if ('timestamp' in timestamp)
          {
            timestamp = timestamp.timestamp;
          } else

          {
            timestamp = '';
          }
        } else

        {
          timestamp_options = timestamp.split('|');
          if (timestamp_options.length == 2)
          {
            timestamp = timestamp_options[0];
            timestamp_options = timestamp_options[1];
          } else

          {
            timestamp = timestamp_options[0];
            timestamp_options = false;
          }
        }

        switch (timestamp) {

          case "now":
          case "today":
            date = new Date();
            break;
          case "yesterday":
            date = new Date();
            date.setDate(date.getDate() - 1);
            break;
          case "tomorrow":
            date = new Date();
            date.setDate(date.getDate() + 1);
            break;
          default:
            {
              let actioned = false;
              if (!isNaN(timestamp))
              {
                date = new Date(timestamp * 1000);
                actioned = true;
              } else
              if (timestamp.includes('-W'))
              {
                let yearWeekDayDate = function__getDateFromYearWeekDay(timestamp);
                if (yearWeekDayDate)
                {
                  date = yearWeekDayDate;
                  actioned = true;
                }
              }
              if (!actioned)
              {
                // Assume mysql timestamp
                /**
                console.debug(timestamp);
                let t = timestamp.split(/[- :]/);
                console.debug(t);
                date = new Date(Date.UTC(t[0], t[1]-1, t[2], t[3], t[4], t[5]));
                console.debug(date);
                */
                date = new Date(timestamp);
              }
            }
            break;}


        if (timestamp_options)
        {
          if (timestamp_options == 'days_in_week_array')
          {
            let yw = function__getYearWeekNo(date);
            if (yw.length == 2)
            {
              date = [];
              for (let i = 0; i < 6; i++)
              {
                date.push(function__getDateFromYearWeekDay(yw[0] + '-W' + yw[1] + '-' + i));
              }
            }
          } else
          if (timestamp_options.endsWith('days'))
          {
            timestamp_options = timestamp_options.replace("days", "");
            if (timestamp_options.startsWith('+'))
            {
              timestamp_options = timestamp_options.replace("+", "").trim();
              if (!isNaN(timestamp_options))
              {
                date.setDate(date.getDate() + timestamp_options);
              }
            } else
            if (timestamp_options.startsWith('-'))
            {
              timestamp_options = timestamp_options.replace("-", "").trim();
              if (!isNaN(timestamp_options))
              {
                date.setDate(date.getDate() - timestamp_options);
              }
            }
          } else
          if (timestamp_options.endsWith('years'))
          {
            timestamp_options = timestamp_options.replace("years", "");
            if (timestamp_options.startsWith('+'))
            {
              timestamp_options = timestamp_options.replace("+", "").trim();
              if (!isNaN(timestamp_options))
              {
                date.setFullYear(date.getFullYear() + timestamp_options);
              }
            } else
            if (timestamp_options.startsWith('-'))
            {
              timestamp_options = timestamp_options.replace("-", "").trim();
              if (!isNaN(timestamp_options))
              {
                date.setFullYear(date.getFullYear() - timestamp_options);
              }
            }
          }
        }
        if (Array.isArray(date))
        {
          dates = date;
        } else

        {
          dates.push(date);
        }
      }

      for (let date of dates)
      {
        let return_date = '';
        switch (format) {

          case "yearweekno":
            return_date = function__getYearWeekNo(date);
            break;
          case "timestamp_y-m-d":
            return_date = new Date(date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2)).getTime() / 1000;
            break;
          case "Y-m-d":
            return_date = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2);
            break;
          case "since":
            //calculate time difference
            let time_difference = new Date().getTime() - date.getTime();

            //calculate days difference by dividing total milliseconds in a day
            let dwmy = calculateTimimg(Math.trunc(time_difference / (1000 * 60 * 60 * 24)));

            let _return_date = [];

            if ('years' in dwmy && dwmy.years > 0)
            {
              _return_date.push(dwmy.years + ' year' + (dwmy.years == 1 ? '' : 's'));
            }

            if ('months' in dwmy && dwmy.months > 0)
            {
              _return_date.push(dwmy.months + ' month' + (dwmy.months == 1 ? '' : 's'));
            }

            if ('weeks' in dwmy && dwmy.weeks > 0)
            {
              _return_date.push(dwmy.weeks + ' week' + (dwmy.weeks == 1 ? '' : 's'));
            }

            if ('days' in dwmy && dwmy.days > 0)
            {
              _return_date.push(dwmy.days + ' day' + (dwmy.days == 1 ? '' : 's'));
            }

            return_date = dwmy;

            return_date.string = _return_date.join(", ");

            break;
          default:
            const nth = function (d) {
              if (d > 3 && d < 21) return 'th';
              switch (d % 10) {
                case 1:return "st";
                case 2:return "nd";
                case 3:return "rd";
                default:return "th";}

            };

            var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            var year = date.getFullYear();
            var month = months[date.getMonth()];
            var day = date.getDate();

            // Hours part from the timestamp
            var hours = date.getHours();
            // Minutes part from the timestamp
            var minutes = "0" + date.getMinutes();

            // Will display time in YYYY/MM/DD 10:30:23 format
            if (show_time)
            {
              return_date = day + '' + nth(day) + ' ' + month + ' ' + year + ' at ' + hours + ':' + minutes.substr(-2);
            } else

            {
              return_date = day + '' + nth(day) + ' ' + month + ' ' + year;
            }}

        return_dates.push(return_date);
      }

      if (return_dates.length == 1 && singe_mode)
      {
        return return_dates[0];
      } else

      {
        return return_dates;
      }
    };

    PROCESS.moustache = function (target, _data = {}, multi_data = false)
    {
      let results = [];
      let function__prepData = function (data = {}) {
        let template_data = {};
        template_data.globals = {};
        template_data.session = {};
        template_data.data = JSON.parse(JSON.stringify(data));
        if (typeof template_data.data === 'object' && template_data.data !== null)
        {
          if ('::timestamp_to_date' in template_data.data)
          {
            template_data.globals.date = function () {
              return PROCESS.format_date(template_data.data['::timestamp_to_date'], 'Y-m-d');
            };
          }
        }
        template_data.globals.today = function () {
          return PROCESS.format_date('now', 'Y-m-d');
        };
        if (!('date' in template_data.globals))
        {
          template_data.globals.date = function () {
            return PROCESS.format_date('now', 'Y-m-d');
          };
        }
        template_data.globals.yesterday = function () {
          return PROCESS.format_date('yesterday', 'Y-m-d');
        };
        template_data.globals.yesterday_timestamp = function () {
          return PROCESS.format_date('yesterday', 'timestamp_y-m-d');
        };
        template_data.globals.today_timestamp = function () {
          return PROCESS.format_date('now', 'timestamp_y-m-d');
        };
        template_data.globals.tomorrow = function () {
          return PROCESS.format_date('tomorrow', 'Y-m-d');
        };
        {
          template_data.globals.days = {};
          template_data.globals.days.monday = function () {
            let yearweek = PROCESS.format_date('now', 'yearweekno');
            if (Array.isArray(yearweek) && yearweek.length == 2)
            {
              return PROCESS.format_date(yearweek[0] + '-W' + yearweek[1] + '-0', 'Y-m-d');
            }
            return null;
          };
          template_data.globals.days.tuesday = function () {
            let yearweek = PROCESS.format_date('now', 'yearweekno');
            if (Array.isArray(yearweek) && yearweek.length == 2)
            {
              return PROCESS.format_date(yearweek[0] + '-W' + yearweek[1] + '-1', 'Y-m-d');
            }
            return null;
          };
          template_data.globals.days.wednesday = function () {
            let yearweek = PROCESS.format_date('now', 'yearweekno');
            if (Array.isArray(yearweek) && yearweek.length == 2)
            {
              return PROCESS.format_date(yearweek[0] + '-W' + yearweek[1] + '-2', 'Y-m-d');
            }
            return null;
          };
          template_data.globals.days.thursday = function () {
            let yearweek = PROCESS.format_date('now', 'yearweekno');
            if (Array.isArray(yearweek) && yearweek.length == 2)
            {
              return PROCESS.format_date(yearweek[0] + '-W' + yearweek[1] + '-3', 'Y-m-d');
            }
            return null;
          };
          template_data.globals.days.friday = function () {
            let yearweek = PROCESS.format_date('now', 'yearweekno');
            if (Array.isArray(yearweek) && yearweek.length == 2)
            {
              return PROCESS.format_date(yearweek[0] + '-W' + yearweek[1] + '-4', 'Y-m-d');
            }
            return null;
          };
          template_data.globals.days.saturday = function () {
            let yearweek = PROCESS.format_date('now', 'yearweekno');
            if (Array.isArray(yearweek) && yearweek.length == 2)
            {
              return PROCESS.format_date(yearweek[0] + '-W' + yearweek[1] + '-5', 'Y-m-d');
            }
            return null;
          };
          template_data.globals.days.sunday = function () {
            let yearweek = PROCESS.format_date('now', 'yearweekno');
            if (Array.isArray(yearweek) && yearweek.length == 2)
            {
              return PROCESS.format_date(yearweek[0] + '-W' + yearweek[1] + '-6', 'Y-m-d');
            }
            return null;
          };
        }


        let env_context = _HELPERS.run('env', 'getContext', [false, function () {return {};}]);
        if (typeof env_context === 'object' && env_context !== null)
        {
          template_data['env'] = {};
          template_data['env']['context'] = env_context;
        }
        /**
          if(typeof MATCH === 'object')
          {
            for(let a_match in MATCH)
            {
              if(typeof MATCH[a_match] === 'object')
              {
                if('function' in MATCH[a_match])
                {
                  template_data[a_match]=MATCH[a_match].function();
                }
                else if('values' in MATCH[a_match])
                {
                  if(Array.isArray(MATCH[a_match].values))
                  {
                    template_data[a_match]=MATCH[a_match].values.join(',');
                  }
                  else
                  {
                    template_data[a_match]=MATCH[a_match].values;
                  }
                }
                else
                {
                  template_data[a_match]='';
                }
              }
              else
              {
                template_data[a_match]=MATCH[a_match];
              }
            }
          }
          */

        template_data.__function = {};
        template_data.__function.helpers = {};
        template_data.__function.helpers.run = function ()
        {
          return function (val, render) {
            let text_object = ['unknown-helper', 'unknown-helper', 'unknown-params'];
            try
            {
              //let text = render(val);
              if (_HELPERS.has('tools', 'runBrackets'))
              {
                return _HELPERS.run('tools', 'runBrackets', [val, template_data.session, this]);
              } else

              {
                throw 'tools.runBrackets Missing!';
              }

            }
            catch (ex)
            {
              _LOG('error', 'moustache', 'Error ' + ex + ' in __function.helpers.run("' + text_object[0] + '","' + text_object[1] + '")', [val, text_object]);
              return '';
            }
          };
        };
        return template_data;
      };
      let function___processMoustache = function (template, data = {})
      {
        if (!_HELPERS.has('moustache', 'render'))
        {
          _LOG('warning', 'moustache', 'Helper helper(moustache,render) required! Returning basic moustache processing.');

          let return_processed = _HELPERS.run('tools', 'processMoustachedValuesFromJSON', [data, template]);
          _LOG('debug', 'PROCESS.moustache.function___processMoustache', 'Processed processMoustachedValuesFromJSON...', [template, data, return_processed]);
          return return_processed;
        } else

        {
          let return_processed = _HELPERS.run('moustache', 'render', [template, data]);
          _LOG('debug', 'PROCESS.moustache.function___processMoustache', 'Processed moustache...', [template, data, return_processed]);
          return return_processed;
        }
      };

      let data_array = [];

      if (multi_data)
      {
        if (!Array.isArray(_data))
        {
          data_array.push(_data);
        } else

        {
          data_array = _data;
        }
      } else

      {
        data_array.push(_data);
      }

      for (let data of data_array)
      {
        let result = '';
        let target_data = function__prepData(data);
        if (Array.isArray(target))
        {
          result = [];
          for (let i = 0; i < target.length; i++)
          {
            result[i] = function___processMoustache(target[i], target_data);
          }
        } else
        if (typeof target === 'object')
        {
          result = {};
          for (let atarget in target)
          {
            result[atarget] = function___processMoustache(target[atarget], target_data);
          }
        } else

        {
          result = function___processMoustache(target, target_data);
        }
        results.push(result);
      }

      if (data_array.length == 1)
      {
        results = results[0];
      }
      return results;
    };

    PROCESS.deserialize = function (string, params = {}, mode = '')
    {
      if (typeof string === 'string')
      {
        try
        {
          if (string.startsWith("{'"))
          {
            string = string.replaceAll("'", '"');
          }
          string = JSON.parse(`` + string + ``);
        }
        catch (ex)
        {
          try
          {
            string = JSON.parse(atob(`` + string + ``));
          }
          catch (ex)
          {
            // Ok
          }
        }
        return string;
      }
      throw 'Not a string';
    };

    PROCESS.comment = function (element, alias = '', deserialize = true)
    {
      let return_content = {};
      if (element instanceof HTMLElement)
      {
        let comments = Array.from(element.childNodes).
        filter(node => node.nodeType === Node.COMMENT_NODE).
        map(comment => comment.textContent.trim());
        for (let i = 0; i < comments.length; i++)
        {
          let comment_key = '';
          let first_line_char = comments[i].indexOf("\n");
          let first_line = comments[i].slice(0, first_line_char).trim();
          let this_comment = comments[i].slice(first_line_char, comments[i].length).trim();
          if (first_line.startsWith('[') && first_line.endsWith(']'))
          {
            comment_key = first_line.replaceAll('[', '').replaceAll(']', '');
          }
          if (comment_key.length > 0)
          {
            if (deserialize)
            {
              try
              {
                this_comment = PROCESS.deserialize(this_comment);
              }
              catch (ex)
              {
                // Ok.... no then
              }
            }
            _LOG('debug', 'comment', 'Comment [' + i + '](' + comment_key + ')', comments[i]);
            if (alias.length > 0)
            {
              if (comment_key == alias)
              {
                return this_comment;
              }
            } else

            {
              return_content[comment_key] = this_comment;
            }
          }
        }
      }
      if (alias.length > 0)
      {
        return null;
      }
      return return_content;
    };

    PROCESS.data = function (data, params = {}, mode = 'ommit')
    {
      let function___processData = function (data, params)
      {
        let _function__matchValues = function (type, field_value, data_value) {
          let return_value = false;
          if (!Array.isArray(data_value))
          {
            data_value = [data_value];
          }
          for (let adata_value of data_value)
          {
            switch (type) {

              case "not":
              case "!":
                return_value = true;
                if (adata_value == field_value)
                {
                  return false;
                }
                break;
              case "regex":
                if (typeof adata_value === 'string' || typeof field_value === 'string')
                {
                  if (adata_value.test(field_value))
                  {
                    return true;
                  }
                }
                return false;
              case "gt":
                if (!isNaN(field_value) && !isNaN(adata_value))
                {
                  if (Number(adata_value) >= Number(field_value))
                  {
                    return true;
                  }
                }
                return false;
              case "lt":
                if (!isNaN(field_value) && !isNaN(adata_value))
                {
                  if (Number(adata_value) <= Number(field_value))
                  {
                    return true;
                  }
                }
                return false;
              default:
                if (typeof field_value === 'object' && typeof adata_value === 'object')
                {
                  if (adata_value == field_value)
                  {
                    return true;
                  }
                } else
                if ("" + adata_value == "" + field_value)
                {
                  return true;
                }

                break;}

          }
          return return_value;
        };
        let _function__recursiveTest = function (data, field, field_value) {
          //console.error('#_processData._function__recursiveTest...',data,field,field_value);
          if (!Array.isArray(field))
          {
            field = field.split('.');
          }
          let thisField = field[0];
          if (thisField in data)
          {
            //console.error('#_processData@1',thisField);
            if (field.length == 1)
            {
              //console.error('#_processData@2',field);
              if (!(typeof field_value === 'object'))
              {
                let _field_value = field_value;
                field_value = {};
                field_value.eq = _field_value;
              }
              //console.error('#_processData@3',field_value);
              for (let _a_field_value_type in field_value)
              {
                let explode_values = field_value[_a_field_value_type];
                if (!Array.isArray(explode_values))
                {
                  explode_values = explode_values.split(';');
                }
                if (explode_values.length == 1 && typeof explode_values[0] === 'string')
                {
                  explode_values = explode_values[0].split(',');
                }
                //console.error('#_processData@4',explode_values);
                let success_count = 0;
                let count = explode_values.length;
                _LOG('debug', 'data._processData', '_function__recursiveTest', [_a_field_value_type, explode_values, data[thisField]]);
                for (let i = 0; i < count; i++)
                {
                  if (_function__matchValues(_a_field_value_type, explode_values[i], data[thisField]))
                  {
                    _LOG('debug', 'data._processData', 'Success _function__matchValues', [_a_field_value_type, explode_values[i], data[thisField]]);
                    success_count++;
                  } else

                  {
                    _LOG('debug', 'data._processData', 'Failed _function__matchValues', [_a_field_value_type, explode_values[i], data[thisField]]);
                  }
                }
                if (count > 1)
                {
                  switch (_a_field_value_type) {

                    case "eq":
                    case "and":
                      if (success_count == count)
                      {
                        success_count = 1;
                      } else

                      {
                        success_count = 0;
                      }
                      break;
                    case "not":
                      if (success_count == count)
                      {
                        success_count = 1;
                      } else

                      {
                        success_count = 0;
                      }
                      break;}

                }
                if (success_count > 0)
                {
                  return true;
                } else

                {
                  return false;
                }
              }
            } else

            {
              field.shift();
              return _function__recursiveTest(data[thisField], field, field_value);
            }
          }
          throw 'Unknown';
        };

        let count = 0;
        let offset = '_[offset]' in params ? params['_[offset]'] : 0;
        let limit = '_[limit]' in params ? params['_[limit]'] : 0;
        let sort = '_[sort]' in params ? params['_[sort]'] : false;
        let distinct_limit = '_[distinct|limit]' in params ? params['_[distinct|limit]'] : false;

        if ('_' in params && typeof params['_'] === 'object')
        {
          if ('offset' in params['_'])
          {
            offset = params['_'].offset;
          }
          if ('limit' in params['_'])
          {
            limit = params['_'].limit;
          }
          if ('sort' in params['_'])
          {
            sort = params['_'].sort;
          }
          if ('distinct|limit' in params['_'])
          {
            distinct_limit = params['_']['distinct|limit'];
          }
        }


        let continue_processing = true;
        _LOG('debug', 'data._processData', 'Processing ' + data.length + ', items...', data);
        for (let i = 0; i < data.length; i++)
        {
          if (!continue_processing)
          {
            break;
          }
          let is_deleted = false;
          for (let a_param in params)
          {
            if (!a_param.startsWith('_') && !is_deleted)
            {
              try
              {
                _LOG('debug', 'data._processData', 'function___processData', { 'data[i]': data[i], 'a_param': a_param, 'params[a_param]': params[a_param] });
                if (!_function__recursiveTest(data[i], a_param, params[a_param]))
                {
                  throw 'no-match';
                }
              }
              catch (ex)
              {
                if (mode === 'ommit')
                {
                  //console.error('#function___processData::delete',JSON.stringify(data[i]),params);
                  delete data[i];
                  is_deleted = true;
                  break;
                }
              }
            }
          }
          if (!is_deleted)
          {
            count++;
            if (offset > 0 && count < offset)
            {
              delete data[i];
            }
            if (limit > 0 && count > limit)
            {
              continue_processing = false;
            }
          }
        }
        let post_process_data = false;
        if (sort)
        {
          post_process_data = true;
          if (!Array.isArray(sort))
          {
            sort = sort.split(',');
          }
        }
        if (distinct_limit)
        {
          post_process_data = true;

          let _distinct_limit = {};
          distinct_limit = distinct_limit.split('|');
          if (distinct_limit.length == 2)
          {
            _distinct_limit[distinct_limit[0]] = distinct_limit[1];
          }
          distinct_limit = _distinct_limit;
        }
        if (post_process_data)
        {
          let processed_data = [];
          let function__sort = function (fields) {
            return function (a, b) {
              return fields.
              map(function (o) {
                var dir = 1;
                if (o[0] === '-') {
                  dir = -1;
                  o = o.substring(1);
                }
                if (o[0] === '+') {
                  o = o.substring(1);
                }
                if (a[o] > b[o]) return dir;
                if (a[o] < b[o]) return -dir;
                return 0;
              }).
              reduce(function firstNonZeroValue(p, n) {
                return p ? p : n;
              }, 0);
            };
          };

          let has_sort = false;
          let has_distinct_limit = false;
          for (let i = 0; i < data.length; i++)
          {
            let aProcessableRecord = {};
            aProcessableRecord['::data_id'] = i;

            if (typeof distinct_limit === 'object')
            {
              for (let distinct_limit_key in distinct_limit)
              {
                let keys = distinct_limit_key.split(',');
                let value = [];
                for (let akey of keys)
                {
                  value.push(PROCESS.getDataValue(data[i], akey));
                }
                aProcessableRecord[distinct_limit_key] = btoa(value.join('#'));
                has_distinct_limit = true;
              }
            }

            if (sort.length > 0)
            {
              for (let a_sort_item of sort)
              {
                if (a_sort_item[0] === '-' || a_sort_item[0] === '+') {
                  a_sort_item = a_sort_item.substring(1);
                }
                aProcessableRecord[a_sort_item] = PROCESS.getDataValue(data[i], a_sort_item);
                has_sort = true;
              }
            }
            processed_data.push(aProcessableRecord);
          }
          if (has_sort)
          {
            processed_data = processed_data.sort(function__sort(sort));
          }
          if (has_distinct_limit)
          {
            let distinct_limit_count = {};
            for (let i = 0; i < processed_data.length; i++)
            {
              if (typeof processed_data[i] === 'object')
              {
                let this_processed_data = processed_data[i];
                for (let distinct_limit_key in distinct_limit)
                {
                  if ("" + distinct_limit_key in this_processed_data)
                  {
                    if ("" + this_processed_data[distinct_limit_key] in distinct_limit_count)
                    {
                      if (distinct_limit_count[this_processed_data[distinct_limit_key]] > 0)
                      {
                        --distinct_limit_count[this_processed_data[distinct_limit_key]];
                      } else

                      {
                        delete processed_data[i];
                      }
                    } else

                    {
                      distinct_limit_count[this_processed_data[distinct_limit_key]] = distinct_limit[distinct_limit_key];
                    }
                  }
                }
              }
            }
          }
          processed_data = processed_data.filter(function (i) {return i;});
          let new_data = [];
          _LOG('debug', 'data._processData', 'Post processing, Original ' + data.length + ', items...', { 'processed_data': processed_data, 'sort': sort, 'distinct_limit': distinct_limit });
          for (let i = 0; i < processed_data.length; i++)
          {
            if ('::data_id' in processed_data[i])
            {
              new_data.push(data[processed_data[i]['::data_id']]);
            }
          }
          data = new_data;
          _LOG('debug', 'data._processData', 'Post processing, Processed ' + data.length + ', items...', { 'new_data': new_data, 'sort': sort, 'distinct_limit': distinct_limit });
        }
        return data.filter(function (i) {return i;});
      };

      if (Array.isArray(data))
      {
        data = function___processData(data, params);
      } else

      {
        data = function___processData([data], params);
        if (data.length > 0)
        {
          data = data[0];
        }
      }

      return data;
    };

    PROCESS.getDataValue = function (data, key, default_value = null)
    {
      let _function__recursiveGet = function (data, field) {
        //console.error('process.getDataValue._function__recursiveGet...',data,field);
        if (!Array.isArray(field))
        {
          field = field.split('.');
        }
        let thisField = field[0];
        if (thisField in data)
        {
          if (field.length == 1)
          {
            //console.error('process.getDataValue._function__recursiveGet... Found '+thisField,data[thisField]);
            return data[thisField];
          } else

          {
            field.shift();
            //console.error('process.getDataValue._function__recursiveGet... Found '+thisField+' recursing',field,data[thisField]);
            return _function__recursiveGet(data[thisField], field);
          }
        }
        throw 'Unknown';
      };
      try
      {
        return _function__recursiveGet(data, key);
      }
      catch (e)
      {
        return default_value;
      }
    };

    PROCESS.async_hashString = async function (inputString)
    {
      //#TODO test for support
      const encoder = new TextEncoder();
      const data = encoder.encode(inputString);
      const hashBuffer = await crypto.subtle.digest('SHA-256', data);

      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');

      return hashHex;
    };

    _HELPERS.add('process', 'query', PROCESS.query);
    _HELPERS.add('process', 'hash', PROCESS.hash);
    _HELPERS.add('process', 'formatDate', PROCESS.format_date);
    _HELPERS.add('process', 'moustache', PROCESS.moustache);
    _HELPERS.add('process', 'comment', PROCESS.comment);
    _HELPERS.add('process', 'data', PROCESS.data);
    _HELPERS.add('process', 'async_hashString', PROCESS.async_hashString);
    _HELPERS.add('process', 'deserialize', PROCESS.deserialize);
  } else

  {
    _LOG('error', 'init', 'No _HELPERS.add or _HELPERS.has found!', _HELPERS);
  }

}

function processTemplateHelper(_HELPERS, _FILTERS = {}) {

  let _LOG = function (type, source, message, data = '')
  {
    source = 'helper-process.' + source;
    if ('has' in _HELPERS && _HELPERS.has('tools', 'logging'))
    {
      _HELPERS.run('tools', 'logging', [type, source, message, data]);
    } else

    {
      let _message = source + '- ' + message;
      switch (type) {

        case "debug":
          console.debug(_message, data);
          break;
        case "warning":
          console.warn(_message, data);
        case "info":
          console.info(_message, data);
          break;
        case "error":
          console.error(_message, data);
          break;
        default:
          console.log(_message, data);}

    }
  };
  if ('add' in _HELPERS && 'has' in _HELPERS)
  {
    let PROCESS = {};
    PROCESS.templateGetFromPath = function (expected_template, clone = false)
    {
      if (typeof expected_template === 'string' && expected_template.length > 0)
      {
        expected_template = expected_template.split('://');
        if (expected_template.length == 2)
        {
          switch (expected_template[0]) {

            case "id":
              let template_element = document.getElementById(expected_template[1]);
              if (clone)
              {
                template_element.cloneNode(true);
              } else

              {
                return template_element;
              }
              break;
            default:
              _LOG('error', 'template.GetFromPath', 'No or incorrect value for data-dsb-template, missing {type}://{template_var} eg id://my-template', expected_template[1]);}

        } else

        {
          _LOG('error', 'template.GetFromPath', 'No or incorrect value for data-dsb-template, missing {type}://{template_var} eg id://my-template', expected_template);
        }
      }
    };

    PROCESS._isInShadow = function (node)
    {
      for (; node; node = node.parentNode) {
        if (node.toString() === "[object ShadowRoot]") {
          return true;
        }
      }
      return false;
    };

    PROCESS._setOuterHTML = function (target, source)
    {
      if (typeof source === 'string')
      {
        let tmp_element = document.createElement('template');
        tmp_element.innerHTML = source;
        target.parentNode.replaceChild(tmp_element.content, target);
      } else

      {
        target.replace(source);
      }
    };

    PROCESS.template = function (template_element, data, callback_function = false)
    {
      let newItem = false;
      let return_state = false;
      let fuction__postProcessTemplate = {
        add: function (callback) {
          if (typeof callback === 'function')
          {
            if (!Array.isArray(this.que))
            {
              this.que = [];
            }
            this.que.push(callback);
          }
        },
        run: function (data) {
          for (let a_function of this.que)
          {
            a_function(data);
          }
        } };

      try
      {
        _LOG('debug', 'template', 'Processing template...', template_element);

        if (template_element instanceof HTMLElement && !(template_element instanceof HTMLTemplateElement))
        {
          newItem = template_element;
        } else

        {
          if ("content" in document.createElement("template"))
          {
            if (!(template_element instanceof HTMLTemplateElement))
            {
              if (typeof template_element === 'string')
              {
                if (_HELPERS.has('session', 'has') && _HELPERS.run('session', 'has', ['template.' + template_element]))
                {
                  template_element = _HELPERS.run('session', 'get', ['template.' + template_element]);
                }
              }
              //#TODO add templateGetFromPath support
            }

            if (!(template_element instanceof HTMLTemplateElement))
            {
              throw 'Template supplied is not of type HTMLTemplateElement';
            }

            let templateContent = template_element.content;
            newItem = templateContent.cloneNode(true);
            //newItem = document.importNode(template_element.content, true);

          } else

          {
            throw 'HTML templates not supported by your browser';
          }
        }

        fuction__postProcessTemplate.add(function (target) {
          let allForOnClick = [];
          if (target.shadowRoot)
          {
            allForOnClick = target.shadowRoot.querySelectorAll('[data-dsb-onclick]');
          } else

          {
            allForOnClick = target.querySelectorAll('[data-dsb-onclick]');
          }

          allForOnClick.forEach(element => {
            let onclick_event = element.getAttribute('data-dsb-onclick');
            element.removeAttribute('data-dsb-onclick');
            element.onclick = async function ()
            {
              try
              {
                if (onclick_event.startsWith('brackets://'))
                {
                  if (_HELPERS.has('tools', 'runBracketsAsync'))
                  {
                    try
                    {
                      await _HELPERS.run('tools', 'runBracketsAsync', [onclick_event.replace('brackets://', '').replaceAll("'", '"'), {}, element.dataset]);
                    }
                    catch (ex)
                    {
                      throw { "error": "Failed to process brackets", "message": ex };
                    }
                  } else

                  {
                    throw 'runBracketsAsync Missing!';
                  }
                } else

                {
                  throw 'Unknown onlick event';
                }
              }
              catch (ex)
              {
                _LOG('error', 'data-dsb-onclick', ex, element);
                if (_HELPERS.has('ux', 'feedback'))
                {
                  _HELPERS.run('ux', 'feedback', ['error', 'onclick', element, ex]);
                }
              }
            };
          });
        });

        if (typeof data == 'object')
        {
          if (data === null)
          {
            data = {};
          }

          let allForKey = [];
          if (newItem.shadowRoot)
          {
            allForKey = newItem.shadowRoot.querySelectorAll('[data-dsb-template_key]');
          } else

          {
            allForKey = newItem.querySelectorAll('[data-dsb-template_key]');
          }


          for (let i = 0; i < allForKey.length; i++)
          {
            let template_key = allForKey[i].getAttribute('data-dsb-template_key');
            let template_key_target = allForKey[i].getAttribute('data-dsb-template_key_target');
            try
            {
              let function_processValue = function (value) {return value;};
              let template_key_value = null;
              if (template_key.startsWith('{'))
              {
                let template_key_object = PROCESS.deserialize(template_key);
                if ('key' in template_key_object)
                {
                  template_key = template_key_object.key;
                } else

                {
                  throw 'Key missing from template_key_object';
                }
                if ('format' in template_key_object)
                {
                  function_processValue = function (value) {
                    return _HELPERS.run('format', 'value', [value, template_key_object.format]);
                  };
                }
              } else
              if (template_key == '::moustache')
              {
                template_key_value = allForKey[i].innerHTML;
                _LOG('debug', 'template', 'Preparing moustache...', template_key_value);
                function_processValue = function (value) {
                  _LOG('debug', 'template', 'Processing moustache...', [value, data]);
                  return _HELPERS.run('process', 'moustache', [value, data]);
                };
              }

              if (template_key_value === null)
              {
                template_key_value = _HELPERS.run('tools', 'extractFromDot', [data, template_key]);
              }
              allForKey[i].removeAttribute('data-dsb-template_key');
              if (typeof template_key_value !== 'object')
              {
                if (template_key_target === 'outer')
                {
                  PROCESS._setOuterHTML(allForKey[i], function_processValue(template_key_value));
                } else

                {
                  allForKey[i].innerHTML = function_processValue(template_key_value);
                }
              } else
              if (template_key_value instanceof HTMLElement)
              {
                allForKey[i].innerHTML = '';
                if (template_key_target === 'outer')
                {
                  allForKey[i].replace(template_key_value);
                } else

                {
                  allForKey[i].append(template_key_value);
                }
              } else

              {
                throw 'Unknown value type';
              }
              if (typeof callback_function === 'function')
              {
                callback_function(template_key, allForKey[i]);
              }
            }
            catch (ex)
            {
              // so no then...
            }
          };
        }
        if (typeof data === 'object' && data !== null && 'target' in data && data.target instanceof HTMLElement)
        {
          let template_type = 'slots';
          let target_shadowdom = false;
          if ('template_type' in data && data.template_type !== null)
          {
            template_type = data.template_type;
          }
          newItem['dsb_template_root'] = true;
          data.target.attachShadow({ mode: "open" });

          switch (template_type) {

            case "slot":
            case "slots":
              break;
            case "move":
            case "clone_inner":
            case "clone":
              target_shadowdom = 'complete';
              let slot_object = {};
              let slot_default = {};
              data.target.querySelectorAll('[slot]').forEach(element => {
                slot_object[element.getAttribute('slot')] = element;
              });

              newItem.querySelectorAll('slot').forEach(element => {
                let slot_name = element.getAttribute('name');
                if (slot_name == null)
                {
                  let add_element = false;
                  if ('dsb_template_root' in element.parentElement)
                  {
                    add_element = true;
                  } else

                  {
                    element.parentElement.setAttribute('data-dsb-placeholder', 'true');
                  }
                  switch (template_type) {

                    case "clone_inner":
                      element.outerHTML = data.target.innerHTML;
                      break;
                    case "clone":
                      element.outerHTML = data.target.outerHTML;
                      break;
                    case "move":
                      element.replaceWith(data.target);
                      break;}

                  if (add_element)
                  {
                    let wrapper_element = document.createElement('div');
                    wrapper_element.setAttribute('data-dsb-placeholder', 'true');
                    if (element instanceof HTMLElement)
                    {
                      element.append(wrapper_element);
                    } else

                    {
                      element.outerHTML = element.outerHTML + wrapper_element.outerHTML;
                    }
                  }
                  target_shadowdom = 'complete-set-placeholder';
                } else
                if (slot_name in slot_object)
                {
                  switch (template_type) {

                    case "clone_inner":
                      element.outerHTML = slot_object[slot_name].innerHTML;
                      slot_object[slot_name].remove();
                      break;
                    case "clone":
                      element.outerHTML = slot_object[slot_name].outerHTML;
                      slot_object[slot_name].remove();
                      break;
                    case "move":
                    default:
                      element.replaceWith(slot_object[slot_name]);
                      break;}

                } else

                {
                  element.remove();
                }
              });
              break;
            default:
              throw 'Unknown template_type="' + template_type + '"';}


          let tmp_template = document.createElement('template');
          const tempDiv = document.createElement('div');
          tempDiv.appendChild(newItem);
          tmp_template.innerHTML = tempDiv.innerHTML;
          if (data.target.querySelector('[data-dsb-template-vars]') instanceof HTMLElement)
          {
            if (_HELPERS.has('process', 'moustache'))
            {
              let var_object = {};
              data.target.querySelectorAll('[data-dsb-template-vars]').forEach(element => {
                let a_var = element.getAttribute('data-dsb-template-vars');
                try
                {
                  a_var = JSON.parse(a_var.replaceAll("'", '"'));
                  var_object = _HELPERS.run('tools', 'mergeObjects', [var_object, a_var]);
                }
                catch (ex)
                {
                  throw 'Error data-dsb-template-vars="' + a_var + '".. should be an object {"key":"value"}';
                }
              });
              tmp_template.innerHTML = _HELPERS.run('process', 'moustache', [tmp_template.innerHTML, var_object]);
            } else

            {
              throw 'Missing process.moustache, please load helper.';
            }
          }
          //data.target.shadowRoot.appendChild(template_element.content.cloneNode(true));
          data.target.shadowRoot.appendChild(document.importNode(tmp_template.content, true));
          fuction__postProcessTemplate.run(data.target);
          return target_shadowdom ? target_shadowdom : 'complete';
        } else

        {
          fuction__postProcessTemplate.run(newItem);
        }

        if (return_state)
        {
          return return_state;
        }
      }
      catch (ex)
      {
        _LOG('error', 'template', 'Failed to process: ' + ex, [newItem, template_element, data]);
        throw ex;
      }
      return newItem;
    };

    PROCESS.templateDataAttr = function (target, data = {})
    {
      if (target instanceof HTMLElement)
      {
        let actioned = false;
        let innerHTML_template = _HELPERS.run('session', 'get', ['templates.innerHTML']);
        if (innerHTML_template instanceof HTMLTemplateElement)
        {
          let processed_template = PROCESS.template(innerHTML_template, data);
          if (processed_template instanceof HTMLElement || processed_template instanceof DocumentFragment)
          {
            target.append(processed_template);
            actioned = true;
          } else

          {
            _LOG('error', 'templateDataAttr', 'Problem processing template for innerHTML.', processed_template);
          }
        } else

        {
          _LOG('debug', 'templateDataAttr', 'No template for innerHTML found.', innerHTML_template);
        }

        /*
          * #TODO: allow dissabling
          */
        if (target instanceof HTMLElement && target.querySelector('[data-dsb-template]') != null)
        {
          let fragments = target.querySelectorAll('[data-dsb-template]');
          fragments.forEach(element => {
            let expected_template_name = element.getAttribute('data-dsb-template');
            let expected_template_type = element.getAttribute('data-dsb-template-type');
            let expected_template = _HELPERS.run('session', 'get', ['templates.' + expected_template_name]);
            if (!(expected_template instanceof HTMLTemplateElement) && _HELPERS.has('process', 'template.GetFromPath'))
            {
              let imported_template = PROCESS.templateGetFromPath(expected_template_name, false);
              if (imported_template instanceof HTMLTemplateElement)
              {
                _HELPERS.run('session', 'set', ['templates.' + expected_template_name, imported_template]);
                expected_template = imported_template;
              } else

              {
                expected_template = false;
              }
            }

            if (expected_template instanceof HTMLTemplateElement)
            {
              let template_result = PROCESS.template(expected_template, { 'innerHTML': element.innerHTML, 'target': element, 'template_type': expected_template_type });

              if (typeof template_result === 'string' && template_result.startsWith('complete'))
              {
                _LOG('debug', 'templateDataAttr', 'Ok, processed and added new shadowTemplate');
                actioned = true;
              } else
              if (template_result instanceof HTMLElement)
              {
                element.innerHTML = template_result.innerHTML;
                actioned = true;
              } else

              {
                throw { "message": 'Template "' + expected_template_name + '" failed!', 'template_result': template_result };
              }
            }
          });
        }

        return actioned;
      }
      throw 'Missing target element';
    };

    _HELPERS.add('process', 'template', PROCESS.template);
    _HELPERS.add('process', 'template.GetFromPath', PROCESS.templateGetFromPath);
    _HELPERS.add('process', 'template.DataAttr', PROCESS.templateDataAttr);

  } else

  {
    _LOG('error', 'init', 'No _HELPERS.add or _HELPERS.has found!', _HELPERS);
  }

}

function processDataAttsHelper(_HELPERS, _FILTERS = {}, _HOOKS = {}) {

  let _LOG = function (type, source, message, data = '')
  {
    source = 'helper-process.' + source;
    if ('has' in _HELPERS && _HELPERS.has('tools', 'logging'))
    {
      _HELPERS.run('tools', 'logging', [type, source, message, data]);
    } else

    {
      let _message = source + '- ' + message;
      switch (type) {

        case "debug":
          console.debug(_message, data);
          break;
        case "warning":
          console.warn(_message, data);
        case "info":
          console.info(_message, data);
          break;
        case "error":
          console.error(_message, data);
          break;
        default:
          console.log(_message, data);}

    }
  };
  if ('add' in _HELPERS && 'has' in _HELPERS)
  {
    let PROCESS = {};



    PROCESS.dataAtts = async function (data, element_content)
    {
      if (typeof data !== 'object')
      {
        try
        {
          data = JSON.parse(data.replaceAll("'", '"'));
        }
        catch (ex)
        {
          try
          {
            data = JSON.parse(atob(data));
          }
          catch (ex)
          {
            // Ok data is just data
          }
        }

        if (data == null)
        {
          data = this.getAttribute('data');
        }
        if (_HOOKS.has('pre_process_data'))
        {
          await _HOOKS.run('pre_process_data', data);
        }
        if (typeof data === 'string')
        {
          if (data.startsWith('helper://'))
          {
            data = await _HELPERS.runUrlAsync(data, false);
            if (typeof data === 'object' && data !== null && 'data' in data)
            {
              data = data.data;
            }
          } else
          if (data.startsWith('brackets://'))
          {
            if (_HELPERS.has('tools', 'runBracketsAsync'))
            {
              try
              {
                data = await _HELPERS.run('tools', 'runBracketsAsync', [data.replace('brackets://', '').replaceAll("'", '"'), {}, data]);
              }
              catch (ex)
              {
                throw { "error": "Failed to process brackets", "message": ex };
              }
            } else

            {
              throw 'runBracketsAsync Missing!';
            }
          } else
          if ((data.startsWith('http://') || data.startsWith('https://')) && _HELPERS.has('fetch', 'getAsync'))
          {
            data = await _HELPERS.run('fetch', 'getAsync', [data]);
          } else
          if (data.startsWith('#') && _HELPERS.has('process', 'comment'))
          {
            let comment_data = await _HELPERS.run('process', 'comment', [element_content, 'data']);
            _LOG('debug', '_getProcessedData', 'Checking for comment data...', comment_data);
            if (comment_data !== null && typeof comment_data === 'object')
            {
              let hash = '';
              if (_HELPERS.has('process', 'hash'))
              {
                hash = _HELPERS.run('process', 'hash', [data, {}, 'object']);
              }
              _LOG('debug', '_getProcessedData', 'Found comment data, checking hash...', hash);
              if (_HELPERS.has('process', 'data'))
              {
                comment_data = _HELPERS.run('process', 'data', [comment_data, hash, 'ommit']);
              }
              data = comment_data;
            }
            if (_HELPERS.has('tools', 'runBracketsAsync'))
            {
              let comment_brackets = await _HELPERS.run('process', 'comment', [element_content, 'brackets', false]);
              _LOG('debug', '_getProcessedData', 'Checking for brackets comment data...', comment_brackets);
              if (comment_brackets !== null && typeof comment_brackets === 'string')
              {
                data = await _HELPERS.run('tools', 'runBracketsAsync', [comment_brackets, {}, data]);
              }
            }
          } else

          {
            /// ummm... ok
            data = {};
          }
        }
        if (_HOOKS.has('post_process_data'))
        {
          await _HOOKS.run('post_process_data', data);
        }
        if (typeof data !== 'object')
        {
          data = {};
        }
      }
      _LOG('debug', '_getProcessedData', 'Processed data...', data);
      return data;
    };

    PROCESS.settingsAtts = async function (settings)
    {
      if (!(typeof settings === 'object'))
      {
        try
        {
          settings = JSON.parse(settings.replaceAll("'", '"'));
        }
        catch (ex)
        {
          try
          {
            settings = JSON.parse(atob(settings));
          }
          catch (ex)
          {
            settings = null;
          }
        }

        if (settings == null)
        {
          settings = {};
        }

        if ('helpers' in settings)
        {
          let helpers_type = typeof settings.helpers;
          let new_helper = {};
          switch (helpers_type) {

            case "function":
              new_helper = settings.helpers();
              break;
            case "object":
              new_helper = settings.helpers;
              break;
            case "string":
              let _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : null;
              let wait_count = 'helper_wait_count' in settings ? settings.helper_wait_count : 20;
              let check_for_hepler = function (sec)
              {
                if (_global != null && typeof _global === 'object' && settings.helpers in _global)
                {
                  new_helper = _global[settings.helpers];
                  __LOG('debug', 'settings', 'Found helper "' + settings.helpers + '"');
                } else

                {
                  if (wait_count > 0)
                  {
                    wait_count--;
                    __LOG('debug', 'settings', 'Cannot find global object for helper "' + settings.helpers + '"... waiting ' + sec + 's and checking again, ' + wait_count + ' more times... ');
                    setTimeout(function () {
                      check_for_hepler(sec);
                    }, sec * 1000);
                  } else

                  {
                    __LOG('error', 'settings', 'Cannot find global object for helper "' + settings.helpers + '"... timedout after ' + sec + 's x ' + ('helper_wait_count' in settings ? settings.helper_wait_count : 20) + ' times and checking again... ');
                  }
                }
              };
              check_for_hepler('helper_wait' in settings ? settings.helper_wait : 2);
              break;
            default:
              _LOG('warning', 'settings', 'Unknown helpers type "' + helpers_type + '"');
              break;}

          try
          {
            if (typeof new_helper === 'object')
            {
              if ('createContext' in new_helper && typeof new_helper.createContext === 'function')
              {
                new_helper = new_helper.createContext(this.context_name);
              } else

              {
                _LOG('warning', 'settings', 'No helper.createContext found!');
              }
              for (let required_function in _HELPERS)
              {
                if (!(required_function in new_helper) || typeof new_helper[required_function] !== 'function')
                {
                  throw 'Missing required function "' + required_function + '"';
                }
              }
              _HELPERS = new_helper;
            } else

            {
              throw 'Not an object';
            }
          }
          catch (ex)
          {
            _LOG('error', 'settings', 'settings.helpers "' + settings.helpers + '" is not a valid helper: ' + ex, { new_helper });
          }

        }
        _settings = settings;
      }
      _LOG('debug', '_getProcessedSettings', 'Processed settings...', settings);
      return settings;
    };

    _HELPERS.add('process', 'atts.data', PROCESS.dataAtts);
    _HELPERS.add('process', 'atts.settings', PROCESS.settingsAtts);

  } else

  {
    _LOG('error', 'init', 'No _HELPERS.add or _HELPERS.has found!', _HELPERS);
  }

}

HTMLDsbElement.prototype._constructorBuildHelpers = function (dsb) {
  dsb.helpers.add('moustache', 'render', function (template, template_data) {
    return mustache.render(template, template_data);
  });
  fetchHelper(dsb.helpers);
  cookiesHelper(dsb.helpers);
  processHelper(dsb.helpers, dsb.filters);
  processTemplateHelper(dsb.helpers, dsb.filters);
  processDataAttsHelper(dsb.helpers, dsb.filters, dsb.hooks);
};

export default HTMLDsbElement;